<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <!-- v-loading="loading" -->
      <div id="ManageBox" class="manageBox" v-loading="loading">
        <el-form ref="CreateCardForm" :model="FormData" :rules="rules">
          <div class="rel-title">{{ $t('newItem.addNewItem') }}</div>
          <div class="mng-row">
            <div class="ctg-block" v-if="ctgShow">
              <div class="row-title row-title-1">{{ $t('newItem.category') }}</div>
              <div class="ctg-title">
                <div class="curr-ctg" v-on:click="CtgItemYes(true)">
                  <div class="ctg-rel-data">
                    <div class="">
                      <span v-if="FormData['FirstCategoryName']">{{ sv(FormData, ['FirstCategoryName', 'FirstCategoryNameCh']) }}</span>
                      <span v-if="FormData['SecondCategoryName']"> / {{ sv(FormData, ['SecondCategoryName', 'SecondCategoryNameCh']) }}</span>
                      <span v-if="FormData['ThirdCategoryName']"> / {{ sv(FormData, ['ThirdCategoryName', 'ThirdCategoryNameCh']) }}</span>
                    </div>
                  </div>
                  <div class="edit">{{ $t('button.edit') }}</div>
                </div>
                <div class="decheck" v-if="ctgItemShow">
                  <div class="decheck-box">
                    <h3>{{ $t('newItem.caution') }}</h3>
                    {{ $t('newItem.cautionInfo') }}
                  </div>
                  <div class="decheck-btn-box">
                    <div v-on:click="CtgItemYes(false, false)">{{ $t('button.yes') }}</div>
                    <div class="yes" v-on:click="CtgItemYes(false)">{{ $t('button.no') }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row-title row-title-1" v-if="!ctgShow">
              + {{ $t('newItem.itemCategory') }}
            </div>
            <div class="select-ctg" v-bind:class="[ctgErr ? 'ctgErr' : '']" v-if="!ctgShow" @click="CtgSelectYes(true)">
              <div class="ctg-btn-val">
                <span v-if="tempFormData['FirstCategoryName']">{{ sv(tempFormData, ['FirstCategoryName', 'FirstCategoryNameCh']) }}</span>
                <span v-if="tempFormData['SecondCategoryName']">/ {{ sv(tempFormData, ['SecondCategoryName', 'SecondCategoryNameCh']) }}</span>
                <span v-if="tempFormData['ThirdCategoryName']">/ {{ sv(tempFormData, ['ThirdCategoryName', 'ThirdCategoryNameCh']) }}</span>
              </div>
              <el-form-item class="categoriesHide" prop="ThirdCategoryId" v-bind:rules="[{ required: true, message: 'Please Select Category', trigger: ['blur', 'change'], },]">
                <el-input type="text" id="CategoriesId" name="ThirdCategoryId" v-bind:value="FormData['ThirdCategoryId'] ? FormData['ThirdCategoryId'] : ''"></el-input>
              </el-form-item>
              <div class="err-tip" v-if="ctgErr">{{ $t('newItem.categoryTip') }}</div>
            </div>
            <div id="CategoriesBox" class="ctg-box container" v-if="ctgSelectShow">
              <div class="ctg-box-tab" v-if="Categories.length">
                <div class="ctg-tab">
                  <div class="ctg-tab-date ctg-first-block">
                    <div class="" v-for="(obj, k) in Categories" v-bind:key="k" v-bind:index="k">
                      <div class="ctg-btn" v-if="k == 0" v-bind:class="[cur[0] == k ? 'active' : '']" v-on:click="setCategories2(obj, k.toString())">{{ sv(obj, ['EnName', 'ChName']) }}</div>
                    </div>
                  </div>
                </div>
                <div class="ctg-tab">
                  <div class="ctg-tab-date ctg-second-block">
                    <div class="" v-for="(obj, k) in Categories[ctgIndex]['children']" v-bind:key="k" v-bind:index="k">
                      <div class="ctg-btn" v-bind:class="[cur[1] == k ? 'active' : '']" v-on:click="setCategories2(obj, ctgIndex + '-' + k)">{{ sv(obj, ['EnName', 'ChName']) }}</div>
                    </div>
                  </div>
                </div>
                <div class="ctg-tab">
                  <div class="ctg-tab-date ctg-third-block">
                    <div class="" v-for="(obj, k) in Categories[ctgIndex]['children'][sCtgIndex]['children']" v-bind:key="k" v-bind:index="k">
                      <div class="ctg-btn" v-bind:class="[cur[2] == k ? 'active' : '']" v-on:click="setCategories2(obj, ctgIndex + '-' + sCtgIndex + '-' + k)">{{ sv(obj, ['EnName', 'ChName']) }}</div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="ctg-check">
                <div @click="CtgYes(false)">{{ $t('button.cancel') }}</div>
                <div class="yes" v-bind:class="[tempFormData['ThirdCategoryName'] ? '' : 'yes-disable',]" @click="CtgYes(true, 'ctgChange')">
                  {{ $t('button.ok') }}
                </div>
              </div>
            </div>
          </div>
          <!-- @*评级卡快捷录入*@ -->
          <!-- @*html5QrCode ID reader*@ -->
          <div id="reader"></div>
          <el-dialog title="评级卡快速录入" :visible.sync="ratingDialogVisible" width="500px" top="20vh" :close-on-click-modal="false" :before-close="ratingHandleClose">
            <div class="rating-upload-box">
              <div class="rating-tips">
                目前仅支持PSA、CGC、GBTC的评级卡
              </div>
              <div class="formbox-rtext">
                <div class="gridly-box">
                  <div class="gridly-item item" v-if="picListLocal.length" v-for="(obj, key) in picListLocal" v-bind:key="obj.key" v-bind:data-id="obj.id" v-bind:id="'imgDivShowImageUrl' + obj.id" draggable="true">
                    <div class="thumbnail" v-bind:class="[key <= 0 ? 'img-selected' : '']" style="width: 100%; height: 100%;">
                      <el-image class="card-pic" v-bind:data-id="obj.id" v-bind:src="obj.ImageUrl + (obj.isPreviewImg ? '' : '?imageView2/2/h/210')" fit="contain" :preview-src-list="showImgList" v-on:click="imageClicked(obj.ImageUrl, key)"></el-image>
                      <span class="is-uploaded" v-if="obj['ImageUrl'].indexOf('blob') <= -1"></span>
                      <a href="javascript:void(0);" class="upload-img-btn dltImg" role="button" v-on:click="dltImgDiv('imgDivShowImageUrl' + obj.id, 'uploadShowImageUrl', obj.id, key)">
                        <img src="/static/images/newcommodity/close.png">
                      </a>
                    </div>
                  </div>
                  <el-upload v-show="picListLocal.length < picListLimit" class="up-img-btn pull-left" ref="ratingUpload" action="" :http-request="uploadImg" list-type="picture" :show-file-list="false" multiple :limit="picListLimit" :on-exceed="handleExceed" :file-list="picList" :before-upload="beforeUpload" :auto-upload="false" :on-change="uploadImgChange" :on-success="uploadImgSuccess" :on-error="uploadImgError" accept="image/jpeg,image/png" :on-remove="handleRemove">
                    <div class="picture_list">
                      <img src="/static/images/newcommodity/pic_add.png" />
                      <span slot="tip" class="el-upload__tip uploadimg-btn">上传图片</span>
                    </div>
                  </el-upload>
                </div>
              </div>
              <!-- <div>picListLocal: {{picListLocal}}</div> -->
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button style="margin: 10px" v-on:click="ratingHandleClose">取消</el-button>
              <el-button style="margin: 10px 0;" type="primary" :loading="decodeLoading" :disabled="ratingDisabled" v-on:click="submitUpload">确认上传</el-button>
            </span>
          </el-dialog>
          <!-- @*评级卡快捷录入ed*@ -->
          <!-- AI录卡 -->
          <el-dialog :title="$t('newItem.aiIdentify')" :visible.sync="aiDialogVisible" width="500px" top="20vh" :close-on-click-modal="false" :before-close="aiHandleClose">
            <div class="rating-upload-box">
              <div class="rating-tips">
                {{ $t('newItem.onlySupporting') }}
              </div>
              <div class="ai-loading" v-if="aiLoading">
                <ai-loading></ai-loading>
                <span v-show="aiCancelShow" class="btns cancel-recognition" @click="cancelRecognition">
                  <em class="cancel-icon"></em>
                  {{ $t('newItem.cancelRecognition') }}
                </span>

              </div>
              <div class="formbox-rtext ai-card-box">
                <div class="gridly-box">
                  <!-- ai 卡正面 -->
                  <div class="gridly-item item" v-if="frontImgUrl.length" draggable="true">
                    <div class="thumbnail" v-bind:class="[]" style="width: 100%; height: 100%;">
                      <el-image class="card-pic" v-bind:src="frontImgUrl[0]['url'] + '?imageView2/2/h/210'" fit="contain" :preview-src-list="[frontImgUrl[0]['url']]">
                      </el-image>
                      <a href="javascript:void(0);" class="upload-img-btn dltImg" role="button" v-on:click="aiDeleteImg('frontImgUrl')">
                        <img src="/static/images/newcommodity/close.png">
                      </a>
                    </div>
                  </div>
                  <el-upload v-show="frontImgUrl.length < 1" class="up-img-btn pull-left" ref="aiUpload" action="" drag :http-request="uploadImgFI" list-type="picture" :show-file-list="false" :limit="1" :file-list="frontImgUrl" :before-upload="beforeUpload" :on-error="uploadImgError" accept="image/jpeg,image/png" :on-remove="handleRemove">
                    <div class="picture_list pic-front">
                      <img src="/static/images/newcommodity/card_front.png" />
                      <span slot="tip" class="el-upload__tip uploadimg-btn text_blue">{{ $t('newItem.frontImg') }}</span>
                    </div>
                  </el-upload>
                </div>
                <div class="gridly-box">
                  <!-- ai 卡反面 -->
                  <div class="gridly-item item" v-if="backendImgUrl.length" draggable="true">
                    <div class="thumbnail" v-bind:class="[]" style="width: 100%; height: 100%;">
                      <el-image class="card-pic" v-bind:src="backendImgUrl[0]['url'] + '?imageView2/2/h/210'" fit="contain" :preview-src-list="[backendImgUrl[0]['url']]">
                      </el-image>
                      <a href="javascript:void(0);" class="upload-img-btn dltImg" role="button" v-on:click="aiDeleteImg('backendImgUrl')">
                        <img src="/static/images/newcommodity/close.png">
                      </a>
                    </div>
                  </div>
                  <el-upload v-show="backendImgUrl.length < 1" class="up-img-btn pull-left" ref="aiUpload" action="" drag :http-request="uploadImgBI" list-type="picture" :show-file-list="false" :limit="1" :file-list="backendImgUrl" :before-upload="beforeUpload" :on-error="uploadImgError" accept="image/jpeg,image/png" :on-remove="handleRemove">
                    <div class="picture_list pic-backend">
                      <img src="/static/images/newcommodity/card_back.png" />
                      <span slot="tip" class="el-upload__tip uploadimg-btn text_blue">{{ $t('newItem.backendImg') }}</span>
                    </div>
                  </el-upload>
                </div>
              </div>
              <!-- <div>picListLocal: {{picListLocal}}</div> -->
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button style="margin: 10px" v-on:click="aiHandleClose">{{ $t('button.cancel') }}</el-button>
              <el-button style="margin: 10px 0;" type="primary" :loading="aiLoading" :disabled="aiLoading || (frontImgUrl.length < 1 || backendImgUrl.length < 1)" v-on:click="aiSubmit">
                {{ $t('button.identify') }}
              </el-button>
            </span>
          </el-dialog>
          <!-- /AI录卡 -->
          <div ref="Picture" id="Picture" class="mng-row">
            <div class="row-title row-title-2">
              {{ $t('newItem.photos') }}
              <!-- <span class="other-enter rating-upload-enter" v-on:click="ratingDialog('rating')">评级卡快速录入<em>beta</em></span> -->
              <span class="other-enter ai-upload-enter" v-on:click="aiDialog('ai')">
                {{ $t('newItem.aiIdentify') }}
                <!-- <em>Beta</em> -->
                <i class="el-icon-arrow-right" style="font-size:12px;color:#5f6dae"></i>
              </span>
            </div>
            <!-- @*展示图*@ -->
            <div class="reltab-formbox clearfix">
              <div class="formbox-rtext">
                <div class="gridly-box">
                  <div class="gridly-item item" v-if="picList.length" v-for="(obj, key) in picList" :key="obj.key" v-bind:data-id="obj.id" v-bind:id="'imgDivShowImageUrl' + obj.id" draggable="true" @dragstart="handleDragStart($event, obj)" @dragover.prevent="handleDragOver($event, obj)" @dragenter="handleDragEnter($event, obj)" @dragend="handleDragEnd($event, obj)">
                    <div class="thumbnail" v-bind:class="[key <= 0 ? 'img-selected' : '', obj['ImageUrl'].indexOf('noimg') > -1 ? 'img-loading' : '',]" style="width: 100%; height: 100%">
                      <el-image class="card-pic" v-bind:data-id="obj.id" v-bind:src="obj.ImageUrl" fit="contain" :preview-src-list="showImgList" v-on:click="imageClicked(obj.ImageUrl, key)"></el-image>
                      <div class="caption" style="position: absolute; bottom: 15px">
                        <input type="hidden" name="Id" v-bind:value="obj.id" />
                        <input type="hidden" name="Url" v-bind:value="obj.ImageUrl" />
                        <input type="hidden" name="Type" v-bind:value="obj.type" />
                        <input type="hidden" name="Sort" v-bind:value="obj.Sort" />
                        <label class="control-label hide">
                          <input type="radio" name="setTitleIMG" class="title-radio" onclick="setTitleImg(this)" v-bind:checked="key <= 0 ? 'checked' : ''" disabled />
                          Title Map
                        </label>
                      </div>
                      <a href="javascript:void(0);" class="dltImg" role="button" @click="dltImgDiv('imgDivShowImageUrl' + obj.id, 'uploadShowImageUrl', obj.id, key)">
                        <img src="/static/images/newcommodity/close.png" />
                      </a>
                    </div>
                  </div>
                  <el-upload v-if="picList.length < picListLimit" class="up-img-btn pull-left" ref="upload" action="" multiple accept="image/jpeg,image/png" :http-request="uploadImg" list-type="picture" :show-file-list="false" :limit="picListLimit" :on-exceed="handleExceed" :file-list="picList" :before-upload="beforeUpload" :on-success="uploadImgSuccess" :on-error="uploadImgError" :on-remove="handleRemove" :with-credentials="true">
                    <div class="picture_list">
                      <img src="/static/images/newcommodity/pic_add.png" />
                      <span slot="tip" class="el-upload__tip uploadimg-btn">{{ $t('newItem.choose') }}</span>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <!-- @*展示图*@ -->
            <div class="row-tip">
              {{ $t('newItem.photosTip').replace(/\{a}/g, "5").replace(/\{b}/g, "10 MB") }}
            </div>
          </div>

          <div id="Detail" class="mng-row">
            <!-- Card information -->
            <div class="row-title row-title-3">{{ $t('newItem.itemInfo') }}</div>
            <!-- @*解决切换类目后选项卡顿？？？*@ -->
            <div v-show="false">
              <span class="rDtl-block" v-for="(obj, key) in cardTitle" :key="key">{{ obj }}</span>
            </div>
            <!-- @*解决切换类目后选项卡顿*@ -->
            <!-- <div class="row-step">Specifics</div> -->
            <div class="custom-box">
              <div class="sport sport-fill">
                <div class="sport-row">
                  <el-row class="sport-block" :gutter="0" style="width: 100%; align-items: center">
                    <el-col :span="7" style="width: 14.4%">
                      <div class="sport-item">
                        {{ $t('newItem.title') }}<em class="isRequired-mark">*</em>：
                      </div>
                    </el-col>
                    <el-col :span="17" style="width: 85.6%;display: flex;justify-content: space-between;align-items: center;">
                      <el-form-item style="width: 100%;" prop="CustomVal" :rules="formRule(1, 'CustomVal', $t('newItem.title'))">
                        <el-input ref="inputCustom" type="textarea" id="InputCustom" class="custom-textarea vip-title" name="CustomVal" v-on:input="CustomInput" v-model="FormData['CustomVal']" :autosize="{ minRows: 2, maxRows: 6 }" autofocus :maxlength="titleMax" show-word-limit :placeholder="$t('newItem.titleText')">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="property-box" v-if="PropertyList.length > 0">
                <!-- titleShow ? 'titleShow' : '', -->
                <div v-bind:class="['sport', item['ControlType'] == 'PropertyBtn' || item['ControlType'] == 'ShowMoreBtn' ? 'sport-fill' : '', showMorePro ? 'showMorePro' : '', item['IsRequired'] == '0' && showMoreBtn && item['ControlType'] != 'ShowMoreBtn' ? 'property-more' : '',]" v-if="item['IsRequired'].split('-').length <= 1 ? true : FormData[item['IsRequired'].split('-')[0]] == item['IsRequired'].split('-')[1] ? true : false" v-for="(item, key) in PropertyList" :key="key" :index="key">

                  <div class="sport-row">
                    <el-row class="sport-block" :gutter="10">
                      <el-col v-if="item['ControlType'] != 'PropertyBtn' && item['ControlType'] != 'ShowMoreBtn'" :span="7">
                        <div class="sport-item">
                          <!-- {{item['ControlName'] }} -->
                          {{ sv(item, ['EnName', 'ChName']) }}<em v-if="item['IsRequired'].split('-')[0] == '1' ? true : item['IsRequired'].split('-')[2] && item['IsRequired'].split('-')[2] == '1' ? true : false" class="isRequired-mark">*</em>:
                        </div>
                        <!-- {{item['ControlName']}}-{{item['ControlType']}}-{{key}} -->
                      </el-col>
                      <el-col :span="item['ControlType'] == 'PropertyBtn' || item['ControlType'] == 'ShowMoreBtn' ? 24 : 17">

                        <div class="form-row sport-row sport-row-fill show-more-row" v-if="item['ControlType'] == 'ShowMoreBtn'">
                          <el-button type="text" :class="['show-more']" v-on:click="ShowMore">
                            {{ showMorePro ? $t('button.showLess') : $t('button.showMore') }} <i :class="[showMorePro ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
                          </el-button>
                        </div>

                        <div class="form-row" v-else-if="item['ControlType'] == 'text'">
                          <!-- @*文本 item['IsRequired'].split('-')[0]=='1'?item['ControlName']:(item['IsRequired'].split('-')[2]&&item['IsRequired'].split('-')[2]=='1'?item['ControlName']:'')*@ -->
                          <el-form-item v-bind:prop="item['ControlName']">
                            <!-- :placeholder="placeHolder[item['ControlName']] ? placeHolder[item['ControlName']]['en'] : ''" -->
                            <el-input type="text" id="" value="" class="sport-select" :placeholder="$ts(`newItem.tips['${item['ControlName']}']`) || ''" maxlength="20" :disabled="item['IsRequired'].split('-')[0] == '1' && titleShow ? true : false" v-model="FormData[item['ControlName']]" v-on:blur="setChangeVal(item, key, 'blur')" @input="inputChange($event)" v-bind:name="item['ControlName']">
                            </el-input>
                          </el-form-item>
                        </div>
                        <div class="form-row" v-else-if="item['ControlType'] == 'switch'">
                          <!-- @*开关*@ -->
                          <el-form-item v-bind:prop="item['IsRequired'].split('-')[0] == '1' ? item['ControlName'] : item['IsRequired'].split('-')[2] && item['IsRequired'].split('-')[2] == '1' ? item['ControlName'] : ''" :rules="formRule(item['IsRequired'].split('-')[0] == '1' ? true : item['IsRequired'].split('-')[2] && item['IsRequired'].split('-')[2] == '1' ? true : '', item['ControlName'], item['ChName'])">
                            <el-switch v-model="FormData[item['ControlName']]" value-key="EnName" class="switch" active-value="Yes" :inactive-value="$t('newItem.no')" :active-text="$t('newItem.yes')" :inactive-text="$t('newItem.no')" :disabled="item['IsRequired'].split('-')[0] == '1' && titleShow ? true : false" v-on:change="switchBtn($event, item, key, item['ControlName'])">
                            </el-switch>
                          </el-form-item>
                        </div>
                        <div class="form-row" v-else-if="item['ControlType'].indexOf('combox-single') > -1">
                          <!-- @*单选*@ -->
                          <el-form-item v-bind:prop="item['IsRequired'].split('-')[0] == '1' ? item['ControlName'] : (item['IsRequired'].split('-')[2] && item['IsRequired'].split('-')[2] == '1' ? item['ControlName'] : '')" :rules="formRule(item['IsRequired'].split('-')[0] == '1' ? true : (item['IsRequired'].split('-')[2] && item['IsRequired'].split('-')[2] == '1' ? true : ''), item['ControlName'], item['EnName'])">
                            <el-select class="sport-select" :loading="sltloading" :no-data-text="item['select'] == undefined ? 'Loading...' : (item['select'] && item['select'].length <= 0 ? 'No Data' : '')" v-bind:name="item['ControlName']" v-model="FormData[item['ControlName']]" value-key="EnName" v-on:click.native="getData('GetKeyValue', '?propertyId=' + item['_id'], key, item['ControlName'], '', item)" :remote="item['select'] && item['select'].length < PropertySelectListLeng ? false : true" :remote-method="(query) => { remoteMethod(query, item['ControlName'], item) }" v-on:change="setChangeVal($event, item, '', '', '', 'isClickChange')" v-bind:data-id="item['_id']" v-bind:allow-create="item['ControlType'].split('-').length >= 3 && item['ControlType'].split('-')[2] == 'customize' ? (item['select'] && item['select'].length > 0 ? true : false) : false" filterable data-live-search="true" :popper-append-to-body="false" :placeholder="$t('newItem.searchOrSelect')">
                              <el-option v-if="item['select']" v-for="(slt, k) in PropertySelectList[item['ControlName']]" :key="k" :label="slt.EnName + ' ' + slt.ChName + ' ' + slt.OtherName" :value="slt">
                                <span class="slt-alias " v-bind:class="[slt.EnName ? 'slt-alias-name' : '']" v-if="slt.EnName">{{ slt.EnName }}</span>
                                <!-- <span class="slt-alias" v-bind:class="[!slt.EnName?'slt-alias-name':'']"
                                  v-if="slt.ChName&&slt.ChName!=slt.EnName"><em v-if="slt.EnName">/</em>{{ slt.ChName}}</span> -->
                                <!-- <span class="slt-alias" v-if="slt.OtherName"><em>/</em>{{ slt.OtherName }}</span> -->
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="form-row" v-else-if="item['ControlType'] == 'combox-more'">
                          <!-- @*多选 Features*@ -->
                          <el-form-item v-bind:prop="item['IsRequired'].split('-')[0] == '1' ? item['ControlName'] + 'Arr' : (item['IsRequired'].split('-')[2] && item['IsRequired'].split('-')[2] == '1' ? item['ControlName'] + 'Arr' : '')" :rules="formRule(item['IsRequired'].split('-')[0] == '1' ? true : (item['IsRequired'].split('-')[2] && item['IsRequired'].split('-')[2] == '1' ? true : ''), item['ControlName'], item['ChName'])">
                            <el-select class="sport-select" :loading="sltloading" :no-data-text="item['select'] == undefined ? 'loading' : (item['select'] && item['select'].length <= 0 ? 'No data' : '')" multiple v-bind:name="item['ControlName'] + 'Arr'" v-bind:value="FormData[item['ControlName'] + 'Arr']" v-on:click.native="getData('GetKeyValue', '?propertyId=' + item['_id'], key, item['ControlName'], '', item)" v-on:change="setChangeVal($event, item['ControlName'] + 'Arr', 'multiple', item, key)" v-bind:data-id="item['_id']" filterable data-live-search="true" :popper-append-to-body="false" :placeholder="$t('enum.plsSelect')">
                              <el-option v-if="item['select']" v-for="(slt, k) in item['select']" :key="slt._id" :label="slt.EnName + ' ' + slt.ChName + ' ' + slt.OtherName" :value="slt.EnName || slt.ChName">
                                <span class="slt-alias " v-bind:class="[slt.EnName ? 'slt-alias-name' : '']" v-if="slt.EnName">{{ slt.EnName }}</span>
                                <!-- <span class="slt-alias" v-bind:class="[!slt.EnName?'slt-alias-name':'']" v-if="slt.ChName"><em
                                    v-if="slt.EnName">/</em>{{ slt.ChName }}</span> -->
                                <span class="slt-alias" v-if="slt.OtherName"><em>/</em>{{ slt.OtherName }}</span>
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </div>

                </div>
              </div>
              <div class="row-step">{{ $t('newItem.description') }}</div>
              <div class="custom-box" style="max-width: 100%">
                <div id="RichText"></div>
              </div>
            </div>
          </div>
          <div id="Price" class="mng-row">
            <div class="row-title row-title-4">
              {{ $t('newItem.pricing') }}
            </div>
            <div class="row-block">
              <div class="row-step">
                {{ $t('newItem.buyingFormat') }}:<em class="isRequired-mark">*</em>
              </div>
              <div class="custom-box">
                <el-form-item class="card-prop" prop="ByWay">
                  <el-radio-group v-model="FormData['ByWay']" :disabled="pageSource == 'scheduled' ? true : false" v-on:change="Steps('Pricing', 'ByWay')">
                    <!-- @*Pricing*@ -->
                    <el-radio :label="2">{{ $t('newItem.auction') }}</el-radio>
                    <el-radio :label="1">{{ $t('newItem.buyItNow') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
            <div class="row-block" v-if="FormData['ByWay'] && FormData['ByWay'] > 0">
              <div class="row-step">
                {{ FormData["ByWay"] == 2 ? $t('newItem.startingBid') : $t('newItem.price') }}<em class="isRequired-mark">*</em>
              </div>
              <div class="custom-box">
                <!-- @*PricingPrice*@ -->
                <el-form-item prop="Price" :rules="formRule(1, 'Price', 'Price')">
                  USD<input type="number" class="ctg-input ctg-input-numb" v-model="FormData['PriceMyUsd']" pattern="[0.99-1000000]" min="0.99" max="1000000" v-on:change="Steps('Pricing', 'Price')" v-on:input="PriceInput('PriceMyUsd', 'Price')" />
                </el-form-item>
              </div>
            </div>
            <div class="row-block" v-if="FormData['ByWay'] == 1">
              <div class="row-step">
                {{ $t('newItem.offers') }}:<em class="isRequired-mark">*</em>
              </div>
              <div class="custom-box">
                <el-form-item prop="Bargain">
                  <el-radio-group v-model="FormData['Bargain']" v-on:change="Steps('Pricing', 'Bargain')">
                    <!-- @*Offers*@ -->
                    <el-radio :label="0">{{ $t('newItem.dontAllowOffers') }}</el-radio>
                    <el-radio :label="1">{{ $t('newItem.allowOffers') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div class="offers-box" v-if="FormData['Bargain'] == 1">
                  <el-row>
                    <el-col>
                      <div class="Offers-input">
                        <div class="required-block">
                          <el-checkbox v-model="minPrice" v-on:change="Steps('Pricing')">{{ $t('newItem.lowerPrice') }}</el-checkbox>
                          <!-- 自动拒绝最低报价金额 formRule(1, 'LPrice', 'Minimum offer amount')-->
                          <el-form-item prop="LPrice" :rules="formRule(1, 'LPrice', '')" v-if="minPrice">
                            USD<input type="number" v-bind:disabled="minPrice == true ? false : true" v-model="FormData['LPriceMyUsd']" pattern="[0.99-1000000]" min="0.99" max="1000000" class="ctg-input ctg-input-numb" v-on:change="Steps('Pricing')" v-on:input="PriceInput('LPriceMyUsd', 'LPrice')" />
                          </el-form-item>
                        </div>
                        <!-- @*OffersMin*@ -->
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <div class="Offers-input">
                        <div class="required-block">
                          <el-checkbox v-model="autoPrice" v-on:change="Steps('Pricing')">{{ $t('newItem.higherPrice') }}</el-checkbox>
                          <!-- 自动接受报价金额 formRule(1, 'HPrice', $t('tips.autoReject'))-->
                          <el-form-item prop="HPrice" :rules="formRule(1, 'HPrice', '')" v-if="autoPrice">
                            USD<input type="number" v-bind:disabled="autoPrice == true ? false : true" v-model="FormData['HPriceMyUsd']" pattern="[0.99-1000000]" min="0.99" max="1000000" class="ctg-input ctg-input-numb" v-on:change="Steps('Pricing')" v-on:input="PriceInput('HPriceMyUsd', 'HPrice')" />
                          </el-form-item>
                        </div>
                        <!-- @*OffersAuto*@ -->
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="row-block" v-if="0">
              <div class="row-step">
                Quantity<em class="isRequired-mark">*</em>
              </div>
              <div class="custom-box">
                <el-form-item prop="QuantitySold">
                  <input type="number" v-bind:disabled="FormData['ByWay'] == 2 || FormData['Bargain'] == 1 ? true : false" v-model="FormData['QuantitySold']" pattern="[1-999999]" min="1" max="999999" class="ctg-input ctg-input-numb" v-on:change="Steps('Pricing')" />
                </el-form-item>
              </div>
            </div>
            <div class="row-block" v-if="FormData['ByWay'] == 1 && FormData['Bargain'] == 0 && 0">
              <!-- @* &&0  关闭限购 *@
                @*一口价1 不允许议价0*@ -->
              <!-- 限制购买数量 -->
              <div class="row-step">
                Limit Quantity<em class="isRequired-mark">*</em>
              </div>
              <div class="custom-box">
                <el-row :gutter="10">
                  <el-col :span="4">
                    <el-form-item prop="IsLimit">
                      <el-radio-group v-model="FormData['IsLimit']" v-on:change="Steps('Pricing')">
                        <!-- @*Offers*@ -->
                        <el-radio :label="0">No</el-radio>
                        <el-radio :label="1">Yes</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="FormData['IsLimit'] == 1">
                    <el-form-item prop="LimitNumber">
                      <input type="number" v-model="FormData['LimitNumber']" placeholder="数量" :pattern="[1 - FormData['QuantitySold']]" min="1" :max="FormData['QuantitySold']" class="ctg-input ctg-input-numb" v-on:change="Steps('Pricing', 'LimitNumber')" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="row-block" v-if="FormData['ByWay']">
              <!-- <div class="row-step">{{FormData['ByWay']==2 ?'Duration:':'Auction Duration:'}}<em class="isRequired-mark">*</em></div> -->
              <div class="row-step">
                {{ $t('newItem.duration') }}<em class="isRequired-mark">*</em>
              </div>
              <div class="custom-box">
                <el-form-item prop="EffectiveDay">
                  <el-radio-group v-model="FormData['EffectiveDay']" :disabled="pageSource == 'scheduled' && FormData['ByWay'] == 1 ? true : false" v-on:change="Steps('Pricing')">
                    <!-- @*Duration*@ -->
                    <div v-if="FormData['ByWay'] == 2">
                      <el-radio :label="1">1 {{ $t('enum.day') }}</el-radio>
                      <el-radio :label="3">3 {{ $t('enum.days') }}</el-radio>
                      <el-radio :label="5">5 {{ $t('enum.days') }}</el-radio>
                      <el-radio :label="7">7 {{ $t('enum.days') }}</el-radio>
                    </div>
                    <div v-else>
                      <el-radio :label="7">7 {{ $t('enum.days') }}</el-radio>
                      <el-radio :label="30">30 {{ $t('enum.days') }}</el-radio>
                    </div>
                  </el-radio-group>
                  <!-- <span v-if="FormData['EffectiveDay']&&FormData['ByWay']==1" class="tip-block cl-grey">发布后将扣除
                    {{FormData['EffectiveDay']==7?1:2}} 个CHP</span> -->
                </el-form-item>
              </div>
            </div>
            <div class="row-block">
              <div class="row-step">
                {{ $t('newItem.startingTime') }}:<em class="isRequired-mark">*</em>
              </div>
              <div class="custom-box">
                <div class="start-time-box">
                  <el-form-item prop="ReleaseType">
                    <el-radio-group class="is-start-time" v-model="FormData['ReleaseType']" v-on:change="Steps('Pricing', 'ReleaseType')">
                      <!-- @*StartingTime*@ -->
                      <el-radio :label="0" :disabled="pageSource == 'scheduled' && FormData['ReleaseType'] == 1 ? true : false">
                        {{ $t('newItem.startImmediately') }}
                      </el-radio>
                      <el-radio :label="1">{{ $t('newItem.scheduleAStartTime') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div class="start-time" v-if="FormData['ReleaseType'] == 1" style="margin: 0 0 0 20px">
                    <el-form-item prop="LastOnTime">
                      <el-date-picker class="place-holder" v-model="StartTime" :clearable="false" type="datetime" :picker-options="pickerOptions" :default-time="curTime" :placeholder="$t('newItem.selectDate')" value-format="yyyy-MM-dd HH:mm:ss" v-on:change="Steps('Pricing', 'date')">
                        <!-- @*StartTime FormData['LastOnTime']*@ -->
                      </el-date-picker>
                      <!-- <span v-if="['PDT','PST'].indexOf($store.state.mGuess)>-1">{{$store.state.mGuess}}</span> -->
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="StartinData">
                {{ $t('newItem.startingTip') }}
              </div>

              <!-- 各地区截标时间【美东、美西、中国、英国】 -->
              <div id="Ending-Box" v-if="endingList.length > 0">
                <div class="show-end-time" @click="CloseEndingList(!ShowEndingList)">
                  <i :class="[ShowEndingList ? 'el-icon-arrow-right' : 'el-icon-arrow-left']"></i>
                </div>
                <div id="Ending-List" v-if="endingList.length > 0 && ShowEndingList">
                  <el-table class="ending-table" :data="endingList" style="width: 100%">
                    <el-table-column prop="date" :label="$t('newItem.referenceEndingTime')" width="200"></el-table-column>
                    <el-table-column prop="enName" :label="$t('newItem.region')"></el-table-column>
                  </el-table>
                </div>
              </div>
              <!-- 各地区截标时间 ed -->
            </div>

            <div class="row-block" v-if="FormData['ByWay'] == 2">
              <div class="row-step">
                {{ $t('newItem.deposit') }}:<em class="isRequired-mark">*</em>
              </div>
              <div class="custom-box">
                <el-form-item prop="IsDeposit">
                  <el-radio-group v-model="FormData['IsDeposit']" class="gu-money-radio" v-on:change="Steps('Pricing')">
                    <!-- @*Gumoney*@ -->
                    <el-radio :label="0">{{ $t('newItem.no') }}</el-radio>
                    <el-radio :label="1">{{ $t('newItem.yes') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div class="deposit-box" v-if="FormData['IsDeposit'] == 1">
                  <el-row>
                    <el-col>
                      <div class="required-block">
                        <div class="required-block_box">
                          <!-- 竞拍担保金（发布点） -->
                          {{ $t('newItem.auctionDeposit') }} (CHP)
                          <!-- 卖家对拍品设置拍品担保金后，买家在竞拍前必须缴纳担保金（发布点）后，方可参与竞拍。 -->
                          <el-tooltip class="item" effect="dark" :content="$t('newItem.depositTip')" placement="top">
                            <i class="el-icon-question"></i>
                          </el-tooltip>
                        </div>
                        <el-form-item prop="DepositNum">
                          <input type="number" class="ctg-input ctg-input-numb" v-model="FormData['DepositNum']" :placeholder="$t('enum.plsEnter')" pattern="[1-10000]" min="1" max="10000" v-on:change="Steps('Pricing', 'DepositNum')" oninput="value=value.replace(/[^\d]/g,'')" />
                          <!-- @*GumoneyMin*@ -->
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <div class="required-block">
                        <div class="required-block_box">
                          <!-- 免担保金信用分起点 -->
                          {{ $t('newItem.depositFree') }}
                          <!-- 卖家对拍品设置买家好评数以后，买家好评数超过免担保门槛，可以免付担保金参与竞拍 -->
                          <el-tooltip class="item" effect="dark" :content="$t('newItem.depositFreeTip')" placement="top">
                            <i class="el-icon-question"></i>
                          </el-tooltip>
                        </div>
                        <el-form-item prop="CreditNum">
                          <input type="number" class="ctg-input ctg-input-numb" v-model="FormData['CreditNum']" :placeholder="$t('enum.plsEnter')" pattern="[1-10000000]" min="1" max="10000000" v-on:change="Steps('Pricing', 'CreditNum')" oninput="value=value.replace(/[^\d]/g,'')" />
                          <!-- @*GumoneyAuto*@ -->
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <!-- <div class="StartinData">(including) positive feedback will bid at once</div> -->
            </div>
          </div>
          <div id="Logistics" class="mng-row">
            <div class="row-title row-title-5">{{ $t('newItem.delivery') }}</div>
            <div class="row-sub-title">
              <!-- 澳门、台湾： -->
              <p v-if="['MO', 'TW'].indexOf(MemberSource) > -1">請務必填寫快遞至大陸的運費模板，否則會導致您少收運費</p>
              <!-- 香港： -->
              <p v-if="['HK'].indexOf(MemberSource) > -1">請務必填寫快遞至大陸以及卡淘澳門轉運倉的運費模板，否則會導致您少收運費</p>
            </div>
            <div v-if="FormData['CommunityPostages']">
              <div v-for="(ex, key) in FormData['CommunityPostages']" :key="key" class="delivery-box">
                <div class="row-step row-step-flex" style="text-transform: capitalize">
                  <span>
                    <!-- {{ key == 0 ? ex.AreaName + ":" : "Other locations:"}} -->
                    {{ key == 0 ? ex.AreaName + ":" : $t('newItem.otherLocations') }}
                    <em class="isRequired-mark">*</em></span>
                  <div class="flex-box" v-if="key > 0">
                    <span @click="AddExcluded(key)">{{ $t('button.edit') }}</span>
                    <span @click="DelExcluded(key)">{{ $t('button.delete') }}</span>
                  </div>
                </div>
                <div class="row-gray" v-if="key > 0">
                  <el-form-item v-bind:prop="'CommunityPostages.' + key + '.AreaID'" :rules="formRule(1, 'AreaID', 'Excluded')">
                    <span>{{ ex.AreaName }}</span>
                  </el-form-item>
                </div>
                <div class="custom-box gu-money freight-row row-block">
                  <el-radio-group v-model="ex['Status']" v-on:change="ExcludedStatus(key)" class="gu-money-radio">
                    <!-- 请选择运费方式 -->
                    <el-form-item v-bind:prop="'CommunityPostages.' + key + '.Status'" v-bind:rules="[{ required: true, message: 'Please choose shipping fee', trigger: ['change', 'blur'], },]">
                      <el-radio :label="1">{{ $t('newItem.freeShipping') }}</el-radio>
                      <el-radio :label="2">{{ $t('newItem.payOnDelivery') }}</el-radio>
                      <el-radio :label="3">{{ $t('newItem.buyerPays') }}</el-radio>
                    </el-form-item>
                  </el-radio-group>
                  <div class="gu-money-yes" v-if="ex['Status'] == 3">
                    <!-- 价格不能低于0 -->
                    <el-form-item v-bind:prop="'CommunityPostages.' + key + '.Price'" v-bind:rules="[
                      {
                        required: true,
                        pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/,
                        message: 'Price must be higher than 0',
                        trigger: ['change', 'blur'],
                      },
                    ]">
                      USD<input type="number" class="ctg-input ctg-input-numb" v-model="ex['PriceMyUsd']" pattern="[1-999999]" min="1" max="999999" v-on:change="ExcludedPrice(key)" />
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
            <div class="delivery-box MoreExcluded" @click="ExcludedYes()">
              + {{ $t('newItem.moreOther') }}
            </div>
            <div class="row-step">{{ $t('newItem.shippingDes') }}</div>
            <div class="custom-box">
              <!-- / Portland OR -->
              <p class="international-p" v-html="$t('newItem.shippingDesDtl')"></p>

              <div class="international-p">
                <!-- #region  各协议阅读并同意提示-->
                <i18n path="newItem.agreementTips" tag="p">
                  <em class="agree-btn list_item text_blue" place="userAgreement" @click="GetAgreements($t('agreement.userAgreement'), 2)">1.&nbsp;{{ $t('agreement.userAgreement') }}</em>
                  <em class="agree-btn list_item text_blue" place="paymentsTerms" @click="GetAgreements($t('agreement.paymentsTerms'), 3)">2.&nbsp;{{ $t('agreement.paymentsTerms') }}</em>
                  <em class="agree-btn list_item text_blue" place="marketingTerms" @click="GetAgreements($t('agreement.marketingTerms'), 4)">3.&nbsp;{{ $t('agreement.marketingTerms') }}</em>
                  <em class="agree-btn text_blue" place="privacyNotice" @click="GetAgreements($t('agreement.privacyNotice'), 1)">{{ $t('agreement.privacyNotice') }}</em>
                </i18n>
                <!-- #endregion -->
              </div>

            </div>
          </div>
          <el-dialog title="Please province selection" :visible.sync="dialogVisible" width="970px">
            <div class="ExcludedDialog">
              <div class="ex-box">
                <div v-if="ChinaArea.length">
                  <div class="ex-list" v-for="(obj, key) in ChinaArea" :key="key" :index="key">
                    <div class="ex-list-tag">{{ obj.name }}</div>
                    <div class="ex-list-name">
                      <div class="area-block" v-for="(ar, k) in obj.area" :key="k" :index="k" v-bind:class="[tempArea['k-' + key + '-' + k] ? 'active' : '', curPostages.indexOf(ar.Code) > -1 && !tempArea['k-' + key + '-' + k] ? 'disActice' : '',]" @click="selectArea(ar, key, k, tempArea['k-' + key + '-' + k] ? 'delt' : 'add', curPostages.indexOf(ar.Code) > -1 && !tempArea['k-' + key + '-' + k] ? 'disable' : '')">
                        <span>{{ ar.EName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ExcludedDialog Excludedbtn">
              <div @click="ExcludedYes()">OK</div>
            </div>
          </el-dialog>
          <!-- <div id="StepBox">
            <div class="step-main">
              <div class="step step-1" v-bind:class="[picList.length > 0 ? 'step-ok iconfont ficon-selected' : '',]">
                <span>Photos</span>
              </div>
              <div class="step step-2 iconfont"
                v-bind:class="DetailsSteps == 0? 'step-ok ficon-selected': DetailsSteps == 1? 'step-ing ficon-selected': ''">
                <span>Specifics</span>
              </div>
              <div class="step step-3 iconfont"
                v-bind:class="PricingSteps == 0? 'step-ok ficon-selected': PricingSteps == 1? 'step-ing ficon-selected': ''">
                <span>Pricing</span>
              </div>
              <div class="step step-4 iconfont"
                v-bind:class="DomesticSteps == 0? 'step-ok ficon-selected': DomesticSteps == 1? 'step-ing ficon-selected': ''">
                <span>Delivery</span>
              </div>
            </div>
          </div> -->
          <!-- 按钮 -->
          <div class="buttons">
            <el-form-item>
              <!-- <el-button class="input_border">Cancel</el-button> -->
              <el-button v-if="pageSource != 'scheduled'" class="sfl input_border" @click="formSubmit('CreateCardForm', 0)">
                {{ $t('button.saveForLater') }}
              </el-button>
              <!-- 定时发布并继续录入: 发布并继续录入-->
              <!-- <el-button style="width:200px;" :disabled='submitLoading' v-bind:class="[submitLoading ? 'submitLoading' : '', 'l-it','sfl2']" @click="formSubmit('CreateCardForm', 1,'saveContinue')">
                {{FormData["ReleaseType"] == 1 ? "List it & Continue" : "List it & Continue"}}
              </el-button> -->
              <el-button style="width: 160px" :disabled="submitLoading" v-bind:class="[submitLoading ? 'submitLoading' : '', 'l-it']" type="primary" @click="formSubmit('CreateCardForm', 1)">
                {{
                  FormData["ReleaseType"] == 1 ? $t('button.scheduledListing') : $t('button.listIt')
                }}
              </el-button>
            </el-form-item>
          </div>
          <!-- <div id="FormSub" class="formbtn">
            <el-form-item>
              <el-button v-bind:class="[submitLoading ? 'submitLoading' : '', 'l-it']" type="primary"
                @click="formSubmit('CreateCardForm', 1)">
                {{FormData["ReleaseType"] == 1 ? "Timing List it" : "List it"}}
              </el-button>
              <el-button v-bind:class="[submitLoading ? 'submitLoading' : '', 'l-it','sfl2']" type="primary"
                @click="formSubmit('CreateCardForm', 1,'saveContinue')">
                {{FormData["ReleaseType"] == 1 ? "定时发布并继续录入" : "发布并继续录入"}}
              </el-button>

              <el-button v-if="pageSource!='scheduled'" class="sfl" type="primary" @click="formSubmit('CreateCardForm', 0)">Save for Later
              </el-button>

              <input class="cancel" type="reset" value="Cancel" />
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <!-- 进度 -->
      <div class="StepBox" ref="StepBox">
        <ul>
          <li @click="anchor('Picture')" v-bind:class="['step-btn', 'iconfont', picList.length > 0 ? 'step-ok iconfont ficon-selected' : '',]">
            {{ $t('newItem.photos') }}
          </li>
          <li @click="anchor('Detail')" v-bind:class="['step-btn', 'iconfont', DetailsSteps == 0 ? 'step-ok ficon-selected' : DetailsSteps == 1 ? 'step-ing ficon-selected' : '',]">
            {{ $t('newItem.itemInfo') }}
          </li>
          <li @click="anchor('Price')" v-bind:class="['step-btn', 'iconfont', PricingSteps == 0 ? 'step-ok ficon-selected' : PricingSteps == 1 ? 'step-ing ficon-selected' : '',]">
            {{ $t('newItem.pricing') }}
          </li>
          <li @click="anchor('Logistics')" v-bind:class="['step-btn', 'iconfont', DomesticSteps == 0 ? 'step-ok ficon-selected' : DomesticSteps == 1 ? 'step-ing ficon-selected' : '',]">
            {{ $t('newItem.delivery') }}
          </li>
        </ul>
      </div>

      <!-- 协议等弹框 -->
      <el-dialog :title="AgreementTitle" :visible.sync="AgreementVisible" width="80%" @close="handleAgreementsClose">
        <div class="agreementsMain" v-loading="AgreementsLoading" v-html="Agreements"></div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="AgreementVisible = false">{{ $t('button.done') }}</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>
<!-- <script type="text/javascript" :src="'@/common/util.js'"></script>
<script type="text/javascript" :src="'@/common/wangEditor/wangEditor.min.js'"></script>
<link rel="stylesheet" :href="'@/common/wangEditor/wangEditor.css'"> -->
<script>
import $ from "jquery";
import jsQR from 'jsqr'
import { Html5Qrcode } from "html5-qrcode";
import Guid from "guid";
var COS = require("cos-js-sdk-v5");
var cos = "",
  cosData = "";
import util from "../../common/util";
import localCategory from "../../common/localCategory"; //本地类目
import E from "wangeditor";
import i18next from "i18next";
var editor = ""; //富文本编辑器
var MVC_isVip = 'true';

import AiLoading from "@/components/ai-loading";
export default {
  data: function () {
    return {
      UserInfo: this.$store.state.UserInfo,
      MemberSource: '',
      Id: null, //商品ID
      isVip: MVC_isVip,//是否VIP
      VipProperty: ["Sports", "Set", "Player", "GameComic"], //vip 必填属性【体育类型，系列，球员，游戏名称】
      DraftId: null, //草稿商品ID
      clone: false, //添加相似卡片
      submitLoading: false, //正在提交
      loading: false, //page loading
      ctgErr: false,
      ctgKeyList: ['FirstCategoryId', 'FirstCategoryName', 'FirstCategoryNameCh', 'SecondCategoryId', 'SecondCategoryName', 'SecondCategoryNameCh', 'ThirdCategoryId', 'ThirdCategoryName', 'ThirdCategoryNameCh'],//列表变量字段
      Categories: [], //1级分类
      ctgIndex: 0, //1级分类index
      SecondCtg: [], //2级分类
      sCtgIndex: 0, //2级分类index
      ThirdCtg: [], //3级分类itleOfTop
      tCtgIndex: 0, //3级分类index
      sltloading: false,
      FormData: {}, //表单提交值
      tempFormData: {}, //临时表单
      PropertyJson: "", //接口属性json url编译
      tempPropertyJson: {}, //接口属性json
      PropertySelectListLeng: 30, //下拉属性大于300条手动搜索
      PropertySelectDefaultShow: 30, //下拉属性大于300条，默认显示条数
      PropertySelectList: {}, //下拉搜索用属性列表
      PropertyList: {}, //属性重组
      PropertyIsRequiredLeng: 0, //属性必选个数
      CurrPropertyKey: 0, //属性当前的index，用于定位‘生成标题’按钮
      tempProperties: [], //临时属性列表
      tempSelectData: {}, //下拉选项全部值（enName，chName，other）
      rules: util.rule("formRule"), //验证规则
      cur: [0, 0, 0], //默认, 不选[-1, -1, -1]
      showMoreBtn: true, //是否显示更多按钮
      showMorePro: false, //根据'更多按钮Show More'显示、隐藏更多属性
      titleShow: false, //是否生成标题
      titleRule: [], //根据接口获取标题规则
      SolrTitle: "", //Solr搜索切词字段
      allowCreateTitle: ['Manufacturer', 'Set', 'Player'],//允许自定义的属性(默认球星卡打卡，切换类目获取对应可自定义属性)
      exclude2: RegExp(/[(\~)(\`)(\@)(\#)(\$)(\%)(\^)(\*)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\;)(\<)(\>)(\「)(\」)(\【)(\】)(\,)(\?)]+/),
      TitleTemp: "", //标题 - 临时存储
      TitleTempAll: "", //标题 - 临时存储 带自定义部分
      SolrTitleTemp: "", //Solr搜索切词字段 - 临时存储
      cardTitle: [], //标题显示
      scrollTop: 0,
      tTop: "",
      titleLength: 0, //标题已用长度
      titleMax: MVC_isVip == 'true' ? 120 : 100,//标题总长
      Custom: 0, //自定义已填数
      remain: 100, //自定义文字数量剩余数
      ctgShow: false,
      ctgSelectShow: false,
      ctgItemShow: false,
      awesome: false,
      uploadUrl: process.env.VUE_APP_BASEURL + "/NewCommodity/UploadImage", //&token=+this.$store.state.ChToken
      uploadFile: "", // new FormData(),
      ImagesUrl: this.$store.state.cosConfig.ImagesUrl, //图片域名地址
      picList: [], //图片列表
      picListLocal: [],//图片列表【本地图片预览、上传】
      uploadImgType: "normal",//图片上传类型，常规："normal",评级卡："rating", 盖高："ai"
      ratingDialogVisible: false,//评级卡图片上传弹框
      qrResult: '',//jsQR 读取数据值
      decodeLoading: false,//评级卡读码中
      ratingDisabled: true,//评级卡上传图片按钮是否禁用
      aiDialogVisible: false,//ai图片上传弹框
      frontImgUrl: [],//正面图片
      backendImgUrl: [],//背面图片
      aiLoading: false,//ai图片上传按钮是否禁用
      aiCancel: false,//手动取消ai识别
      aiCancelShow: false,//手动取消ai识别按钮是否显示
      aiDiscernData: {
        "frontImgUrl": "", // 正面图片 - 上传图片接口返回的URL
        "backendImgUrl": "", // 背面图片 - 上传图片接口返回的URL
      },
      showImgList: [], //展示图放大的列表
      picListLimit: 5,
      dragging: null,
      message: "manageBox-vue",
      selectVal: "",
      //CustomVal: "",//自定义输入值
      ChinaArea: [], //省直辖市
      tempArea: {}, //临时省直辖市（选中）
      tempAreaArr: [], //临时省直辖市（array 用于遍历）
      curPostages: [], //当前已选所有区域
      //Pricing
      //Pricing: -1,//定价方法
      Gumoney: -1, //保证金
      Duration: -1, //有效期
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime(); // 当前日期
          let one = 30 * 24 * 3600 * 1000; //30天
          let oneMonth = curDate + one; //时间差
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > oneMonth
          ); //如果当天可选 就不用减8.64e7
          //return (time.getTime() < Date.now()) || time.getTime() > oneMonth;  //如果当天可选 就不用减8.64e7
        },
      },
      PricingPrice: "",
      Offers: -1,
      minPrice: "",
      autoPrice: "",
      OffersMin: "",
      OffersAuto: "",
      GumoneyMin: "",
      GumoneyAuto: "",
      StartingTime: -1,
      StartTime: "",
      //Domestic
      Domestic: -1,
      DomesticPrice: "",
      Excluded: [{ ex: 0, name: "" }],
      //Steps 0:完成，1：未完成，2：无内容
      DetailsSteps: 2,
      PricingSteps: 2,
      DomesticSteps: 2,
      //排除为止弹框
      dialogVisible: false,
      E_item: "",
      msgOffset: 50,
      placeHolder: util.placeHolder,
      //协议相关
      Agreements: "",
      AgreementTitle: "",
      AgreementVisible: false,
      AgreementsLoading: false,
      endingList: [],//各地区截标时间【美东、美西、中国、英国】
      ShowEndingList: true,
      CountEndTime: null,//立即上架 截标时间随当前时间统计
    };
  },
  components: { AiLoading },
  created: function () {
    var that = this;
    that.NewCos();
    that.$store.dispatch("getExchange")
    // that.$store.dispatch("getExchangeRate")
    //console.log("vue created");
    that.$set(that.FormData, "MemberId", that.UserInfo["MappingUserId"]);
    var _id = that.$route.query.id || "";
    var _did = that.$route.query.did || "";
    var pageSource = that.$route.query.ps || "";
    var clone = that.$route.query.clone || "";
    //console.log("_did_did:", _did);
    that.Id = _id;
    that.DraftId = _did;
    that.pageSource = pageSource;
    that.clone = clone;
    that.$nextTick(function () {
      that.$set(that.FormData, "Id", that.id);
      that.$set(that.FormData, "DraftId", that.DraftId);
    });
    // if (!that.UserInfo["MappingUserId"]) {
    //   that.$message.error("未登录状态，请登录");
    //   location.href = "/";
    // }
  },
  mounted: function () {
    var that = this;
    that.getData("GetCategories");
    let UserDtl = JSON.parse(that.$cookie.get('Card_Seller_USERDTL'));
    let MemberSource = UserDtl.MemberSource;
    that.MemberSource = MemberSource;
    that.getData("GetAreasByCode", "?code=" + MemberSource);//获取用户所属区域
    // that.getData("GetChinaArea");
    that.wangEditor(); //富文本
    that.StepBoxWidth();
    window.onresize = () => {
      return (() => {
        that.StepBoxWidth();
      })()
    }
    let UserDetail = JSON.parse(that.$cookie.get('Card_Seller_UserDetail'));
    let Country = UserDetail.Country;

    let State = UserDetail.State;
    if (!State) {
      this.$confirm(this.$t('tips.plsEditOrigin'), this.$t('tips.tips'), {
        confirmButtonText: this.$t('button.done'),
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning',
        // center: true
      }).then(() => {
        that.$router.push({ name: 'store-origin', params: { getTabNum: 1 } });
      });
    }


    // console.log("$store.state.timeZone", this.$store.state.timeZone)
    // window.addEventListener("scroll", this.scrollToTop, true); //监听滚动-title
    // var tTop = $(document).find("#TitleBox").offset().top;
    // that.tTop = tTop;

    // this.getTimeZone() 获取你想要使用的时区，这里我获取到的是`America/New_York`
    //let str = moment().tz(this.getTimeZone()).set({ 'hour': 23, 'minute': 59, 'second': 59 }).format('MM/DD/YYYY HH:mm:ss')
    //this.today = new Date(str)
    //console.log('America/New_York:', new Date(str));
  },
  beforeDestroy() {
  },
  watch: {
    FormData: {
      handler(fd) {
        this.FormDataWatch(1);
      },
      deep: true,
    },
    titleShow: function (a, b) {
      if (!b) {
        var that = this;
        setTimeout(function () {
          that.$nextTick(function () {
            document.querySelector(`#InputCustom`).focus();
          });
        }, 500);
      }
    },
    picListLocal: {
      handler(fd) {
        var that = this;
        var blobleng = 0;
        fd.map(function (obj, k) {
          if (obj['ImageUrl'].indexOf('blob') > -1) {
            blobleng++
          }
        })
        if (blobleng > 0) {
          that.ratingDisabled = false;
        } else {
          that.ratingDisabled = true;
        }
        //ratingDisabled
      },
      deep: true
    },
  },
  computed: {
    titleVal: function () {
      return function (arrAll, arr) {
        var newArr = arrAll.filter(function (obj, k) {
          return arr.indexOf(obj) > -1;
        });
        //console.log(arrAll, arr, newArr);
        if (newArr.length > 0) {
          return true;
        } else {
          return false;
        }
      };
    },
    curTime: function () {
      var t = util.getTime("HH:mm:ss");
      return t;
    },
    sv: function () {
      //根据语言类型切换语言显示
      var that = this;
      return function (item, obj = []) {
        return that.$store.getters.setValWithLang(item, obj);
      };
    },
    /*表单验证*/
    formRule: function () {
      var that = this;
      return function (required, ControlName, name) {
        var r = [];
        var exg = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/; //大于0且保留小数两位
        if (required) {
          if (ControlName == "LPrice") {
            //低于该价格自动拒绝
            r = [
              {
                validator: function (rule, value, callback) {
                  var _val = that.FormData[ControlName] ? that.FormData[ControlName] : "";
                  if (!_val) {
                    callback(new Error(that.$t('tips.plsFillIn', [name]))); //请填写
                  } else if (parseFloat(_val) && parseFloat(that.FormData["HPrice"]) && parseFloat(_val) >= parseFloat(that.FormData["HPrice"])) {
                    callback(
                      new Error(
                        that.$t('tips.autoReject')
                      )
                    );
                  } else if (parseFloat(_val) <= 0) {
                    callback(new Error(that.$t('tips.priceHigherThan', [0]))); //价格不能低于0
                  } else if (!exg.test(parseFloat(_val))) {
                    callback(
                      new Error(that.$t('tips.priceTwoDec'))
                    );
                  } else {
                    // 验证通过
                    callback();
                  }
                },
                trigger: ["change", "blur"],
              },
            ];
          } else if (ControlName == "HPrice") {
            //自动接受价格
            r = [
              {
                validator: function (rule, value, callback) {
                  var _val = that.FormData[ControlName] ? that.FormData[ControlName] : "";
                  if (!_val) {
                    callback(new Error(that.$t('tips.plsFillIn', [name])));
                  } else if (
                    !that.FormData["Price"] ||
                    parseFloat(_val) >= parseFloat(that.FormData["Price"])
                  ) {
                    callback(
                      new Error(
                        that.$t('tips.autoAccept')
                      )
                    ); //自动接受价格必须小于原价
                  } else if (parseFloat(_val) <= 0) {
                    callback(new Error(that.$t('tips.priceHigherThan', [0]))); //价格不能低于0
                  } else if (!exg.test(parseFloat(_val))) {
                    callback(
                      new Error(that.$t('tips.priceTwoDec'))
                    );
                  } else {
                    // 验证通过
                    callback();
                  }
                },
                trigger: ["change", "blur"],
              },
            ];
          } else if (ControlName == "Price") {
            //价格
            r = [
              {
                validator: function (rule, value, callback) {
                  var _val = that.FormData[ControlName] ? that.FormData[ControlName] : "";
                  var _val_Usd = that.FormData[ControlName + "MyUsd"] ? that.FormData[ControlName + "MyUsd"] : "";
                  var priceMinUsd = 0.99;//that.$store.getters.priceExchange(0.99, "USD");//最小金额0.99美金
                  var priceMaxUsd = 1000000;//that.$store.getters.priceExchange(1000000, "USD");//最大金额100W人民币，约$145400
                  // console.log("parseFloat(_val)", priceMaxUsd)
                  if (!_val) {
                    callback(new Error(that.$t('tips.plsFillIn', [name])));
                  } else if (parseFloat(_val_Usd) < priceMinUsd) {//美金
                    callback(new Error(that.$t('tips.priceHigherThan', ['$' + priceMinUsd]))); //价格不能低于0.99美金
                  } else if (parseFloat(_val_Usd) > priceMaxUsd) {//美金
                    callback(new Error(that.$t('tips.priceLessThan', ['$1,000,000']))); //价格不能高于1000000美金
                  } else if (!exg.test(parseFloat(_val))) {
                    callback(
                      new Error(that.$t('tips.priceTwoDec'))
                    );
                  } else {
                    // 验证通过
                    callback();
                  }
                },
                trigger: ["change", "blur"],
              },
            ];
          } else if (ControlName == "AreaID") {
            r = [
              {
                validator: function (rule, value, callback) {
                  if (value == "") {
                    callback(new Error(that.$t('tips.plsSelLoc')));
                  } else {
                    callback();
                  }
                },
                trigger: ["change", "blur"],
              },
            ];
          }
          else if (ControlName == "CustomVal") {
            r = [
              {
                validator: function (rule, value, callback) {
                  var _val = that.FormData[ControlName] ? that.FormData[ControlName] : "";
                  if (_val) _val = _val.toLowerCase();
                  // console.log("not:",_val.indexOf("not "), _val.indexOf(" not "), _val.indexOf(" not"), _val.indexOf("not ") == 0 , _val.indexOf(" not ") > -1 , _val.indexOf(" not") == _val.length-4)
                  if (!_val) {
                    callback(new Error(that.$t('tips.plsFillIn', [name])));
                  }
                  else if (_val.length >= 4 && (_val.indexOf("not ") == 0 || _val.indexOf(" not ") > -1 || _val.indexOf(" not") == _val.length - 4)) {
                    callback(new Error(that.$t('tips.CannotContain', ['not'])));
                  }
                  else {
                    // 验证通过
                    callback();
                  }
                },
                trigger: ["change", "blur"],
              },
            ];
          }
          else {
            r = [
              //{ required: true, message: '请选择' + name, trigger: ['change', 'blur'] },
              {
                validator: function (rule, value, callback) {
                  var _val = that.FormData[ControlName] ? that.FormData[ControlName] : "";
                  if (_val) _val = _val.toLowerCase();
                  // console.log("not:",_val.indexOf("not "), _val.indexOf(" not "), _val.indexOf(" not"))
                  if (!_val) {
                    callback(new Error(that.$t('tips.plsSel', [name])));
                  } else if (/[\u4E00-\u9FA5]/g.test(_val) && _val && ["GameComic", "Set", "Artist"].indexOf(ControlName) == -1) {
                    callback(new Error(that.$t('tips.CannotChinese'))); //不能输入汉字
                  }
                  // else if (_val.length >=4 && (_val.indexOf("not ") == 0 || _val.indexOf(" not ") > -1 || _val.indexOf(" not") == _val.length-4)) {
                  //   callback(new Error(that.$t('tips.CannotContain', ['not'])));
                  // } 
                  else {
                    // 验证通过
                    callback();
                  }
                },
                trigger: ["change", "blur"],
              },
            ];
          }
        }
        return r;
      };
    },
  },
  methods: {
    // 固定宽度
    StepBoxWidth() {
      var Box = $("#Container").outerWidth() - 20;
      var StepBox = $(".main_box").outerWidth();
      var leftBox = $("#Aside").outerWidth();
      this.$refs.StepBox.style.width = StepBox + 'px';
      this.$refs.StepBox.style.left = (Box - StepBox - leftBox) / 2 + leftBox + 'px';
    },
    // 获取数据
    getData(api, data = "", key, saveContinue, cFun, item) {
      var that = this;
      var fun = "",
        method = "GET";
      switch (api) {
        case "GetNewCommodityById": //获取商品详细
          that.loading = true;
          fun = function (res) {
            if (res.result) {
              var _data = res.data;
              if ("version" in _data) {
                delete _data["version"];
              }
              _data["QuantitySold"] = _data["QuantitySold"] <= 0 || !_data["QuantitySold"] ? 1 : _data["QuantitySold"]; //数量
              that.FormData = {
                ...that.FormData, ..._data, PriceMyUsd: that.$store.getters.priceExchange(_data["Price"], "USD"),
                LPriceMyUsd: that.$store.getters.priceExchange(_data["LPrice"], "USD"),
                HPriceMyUsd: that.$store.getters.priceExchange(_data["HPrice"], "USD"),
              };
              if (_data["PropertyJson"]) {
                that.tempPropertyJson = { ...that.tempPropertyJson, ..._data["PropertyJson"], };
              }
              console.log("CardDetail-FormData", that.FormData);
              if ((that.Id == "" && that.DraftId == "") || !that.FormData['ThirdCategoryId']) {
                that.setDefaultCtg(); //设置默认类目
              }
              var ThirdCategoryId = that.FormData["ThirdCategoryId"] ? that.FormData["ThirdCategoryId"] : util["GetCategoriesList"][0]["FirstCategory"]["SecondCategories"][0]["ThirdCategories"][0]["Category"]["_id"];
              console.log("ThirdCategoryId", ThirdCategoryId);
              if (ThirdCategoryId) {
                that.getData("GetCommodityTitleRuleByThirdCategoryId", `?ThirdCategoryId=${ThirdCategoryId}`);
              }
              that.priceExchange("USD"); //汇率转换 rmb->usd
              that.ExcludedReSet(); //运费重排及去除type3、4
            }
            that.loading = false;
          };
          that.$get(api, data).then((res) => {
            console.log("axios-res:", api, res);
            fun(res);
          }).catch((err) => { console.log(err); });
          break;
        case "GetCommodityTitleRuleByThirdCategoryId": //获取商品标题规则
          var ifEdit = function () {
            if (saveContinue != 'ctgChange') {
              //手动获取类别，重新获取规则不走新增、编辑、发布相似相关流程
              if (that.FormData["Id"]) {
                //商品编辑
                that.CardEdit();
              } else {
                //新增默认选中(出现在GetCategories之后)
                that.CtgYes(true);
                that.setKeyVal(); //设置FormData部分属性（定价）
                if (saveContinue) {
                  that.ifStartTime(); //保存并继续发布时间加30s
                }
              }
            }
            if (cFun) {
              new cFun();
            }
          };
          fun = function (res) {
            var tRule = [];
            if (res.Result && res.Data) {
              var rSort = function (array, key) {
                return array.sort(function (a, b) {
                  var x = a[key];
                  var y = b[key];
                  return x < y ? -1 : x > y ? 1 : 0;
                });
              };
              var newTitleRule = rSort(res["Data"]["Rules"], "Index");
              newTitleRule.map(function (obj) {
                tRule.push(obj.ControlName);
              });
              tRule.push("CustomVal"); //规则基础上添加‘自定义’
            } else {
              //无规则取自定义
              tRule.push("CustomVal"); //规则基础上添加‘自定义’
            }
            that.titleRule = tRule;
            console.log("titleRule", that.titleRule);
            ifEdit();
          };
          that.$get(api, data).then((res) => {
            // console.log("axios-res:", api, res);
            fun(res);
          }).catch((err) => {
            //接口请求失败，调取本地标题规则
            var localRule = util.solrTitle(that.FormData["SecondCategoryId"], "", util["cardType"]["getType"](that.FormData["ThirdCategoryName"]));
            // console.log("get-title-rule-err:", localRule);
            that.titleRule = localRule;
            ifEdit();
          });
          break;
        case "GetChinaArea": //获取国内所有省直辖市
          fun = function (res) {
            if (res.result) {
              var _data = res.data;
              var _ChinaArea = util.areaReconfig(_data); //省直辖市 结构重组
              that.ChinaArea = _ChinaArea;
              //console.log("CardDetail-ChinaArea", _ChinaArea);
            }
          };
          that.$get(api, data).then((res) => {
            console.log("axios-res:", api, res);
            fun(res);
          })
            .catch((err) => { console.log(err); });
          break;
        case "GetAreasByCode": //根据code获取区域
          fun = function (res) {
            if (res.result || res.Result) {
              var _data = res.Data;
              var _ChinaArea = util.areaReconfig(_data); //省直辖市 结构重组
              that.ChinaArea = _ChinaArea;
              //console.log("CardDetail-ChinaArea", _ChinaArea);
            }
          };
          that.$get(api, data).then((res) => {
            console.log("axios-res:", api, res);
            fun(res);
          })
            .catch((err) => { console.log(err); });
          break;
        case "GetCategories": //获取分类
          fun = function (res) {
            console.log("Categories:", res);
            if (res) {
              that.Categories = util.resetCategory(localCategory, false);

              /* 默认选中1、2、3级0、0、0 */
              if (that.DraftId) {
                //获取草稿商品详细
                that.getData("GetCommodityById", `?id=${that.DraftId}&memberId=${that.FormData["MemberId"]}`);
              } else {
                //获取商品信息
                var PostageType = that.Id && !that.clone ? "&PostageType=1" : "";
                that.getData("GetNewCommodityById", `?id=${that.Id}&memberId=${that.FormData["MemberId"]}${PostageType}`);
              }
              /* 默认选中1、2、3级0、0、0 */
              //新增默认选中(出现在GetCategories之后)
              //that.CtgYes(true);
            }
          };
          fun(localCategory); //本地类目
          /**接口类目**/
          // that
          //   .$get(api, data)
          //   .then((res) => {
          //     console.log("axios-res:", api, res);
          //     fun(res);
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
          break;
        case "GetKeyValue": //获取属性
          var needFilter = true;//是否 根据体育类型过滤 球员等
          if (!needFilter && that.PropertyList[key]["select"] && that.PropertyList[key]["select"].length) {
            //判断是否已获取该类型属性
            that.sltloading = false;
            return false;
          }
          var propertyGroup = "&propertyGroup="; //根据体育类型过滤 球员等
          //needFilter = false;//暂且关闭
          if (needFilter && that.FormData["Sports"]) {// item['IsRequired'] == "1" && && ["Year", "Manufacturer", "Set", "Player", "League"].indexOf(item['ControlName']) > -1
            propertyGroup += that.FormData["Sports"] || "";//球星卡  根据体育类型过滤
            //console.log(that.FormData["Sports"], 'that.FormData["Sports"]')
          }
          if (needFilter && that.FormData["Franchise"]) {// item['IsRequired'] == "1" && && ["Set", "Round", "Rarity"].indexOf(item['ControlName']) > -1
            propertyGroup += that.FormData["Franchise"] || "";//  集卡社  根据Franchise  IP名称过滤
            //console.log(that.FormData["Franchise"], 'that.FormData["Franchise"]')
          }
          data += propertyGroup;
          that.sltloading = true;
          fun = function (res) {
            that.sltloading = false;
            if (res.result) {
              if (res.data.length < that.PropertySelectListLeng) {
                that.$set(that.PropertySelectList, saveContinue, res.data);
              } else {
                that.$set(that.PropertySelectList, saveContinue, res.data.slice(0, that.PropertySelectDefaultShow));
              }
              that.$set(that.PropertyList[key], "select", res.data);
              that.$set(that.PropertyList[key], "selectVal", "");
              if (cFun) {
                new cFun();
              }
            } else {
            }
            //console.log("GetKeyValue获取属性:", that.PropertyList)
          };
          that.$get(api, data).then((res) => {
            console.log("axios-res:", api, res);
            fun(res);
          }).catch((err) => { console.log(err); });
          break;
        case "SaveCommodity": //保存数据
          // if (that.submitLoading) {
          //   return false;
          // }
          that.submitLoading = true;
          that.loading = true;
          // var loading = this.$loading({
          //   lock: true,
          //   text: 'Saving...',
          //   spinner: 'el-icon-loading',
          //   background: "rgba(250, 250, 250, 0.7)",
          // });
          method = "POST";
          fun = function (res) {
            console.log("***SaveCommoditySaveCommodity***:", res);
            //that.$set(that.FormData, 'PropertyJson', '');
            if (res.result) {
              // that.$loading.close();
              // /market/item/8675863 /market/item/8675864
              that.$message({
                showClose: true,
                message: "Success" || res.msg,
                type: "success",
              });
              // location.href = res.data;
              //window.open(res.Data);

              if (saveContinue) {
                that.$store.state.CardStartTime = that.FormData["LastOnTime"];
                that.$router.go(0);
                // loading.close();
                that.loading = false;
                that.submitLoading = false;
              } else {
                let dl = res["data"].split("/");
                let cid = dl[dl.length - 1];
                let _ByWay = that.FormData["ByWay"],
                  _ReleaseType = that.FormData["ReleaseType"];
                if (_ReleaseType == 1) {
                  that.$router.push({
                    name: "commodity-Scheduled",
                    params: { byWay: _ByWay },
                  });
                } else {
                  let _name = _ByWay == 2 ? "commodity-Auction" : "commodity-Buy";
                  that.$router.push({ name: _name, params: { sortType: 4 } });
                }
                window.open(process.env.VUE_APP_CARD_URL + "/#/carddetails/" + cid);
              }
            } else {
              // loading.close();
              that.loading = false;
              that.submitLoading = false;
              // that.$loading.close();
              that.priceExchange("USD"); //汇率转换 rmb->usd
              if (res.msg) {
                // that.$message.error(res.msg);
              } else {
                that.$message.error("Saving failed");
              }
            }
          };
          that.$post(api, data).then((res) => {
            console.log("axios-res:", api, res);
            fun(res);
          }).catch((err) => { console.log(err); });
          break;
        case "SaveDraftCommodity": //保存数据 草稿
          // if (that.submitLoading) {
          //   return false;
          // }
          that.submitLoading = true;
          that.loading = true;
          // var loading = this.$loading({
          //   lock: true,
          //   text: "Saving to draft...",
          //   spinner: "el-icon-loading",
          //   background: "rgba(0, 0, 0, 0.7)",
          // });
          method = "POST";
          fun = function (res) {
            console.log("***SaveDraftCommodity***:", res);
            // loading.close();
            if (res.result && res.data) {
              that.$message({
                showClose: true,
                message: "Saved to Draft", //已成功保存至草稿
                type: "success",
              });
              that.$set(that.FormData, "Id", "");
              that.$set(that.FormData, "DraftId", res.data);
            } else {
              if (res.msg) {
                that.$message.error(res.msg);
              } else {
                that.$message.error("Saving failed");
              }
            }
            that.submitLoading = false;
            that.loading = false;
            that.priceExchange("USD"); //汇率转换 rmb->usd
          };
          that.$post(api, data).then((res) => {
            console.log("axios-res:", api, res);
            fun(res);
          }).catch((err) => { that.submitLoading = false; loading.close(); });
          break;
        case "GetCommodityById": //商品草稿详细获取
          fun = function (res) {
            // console.log("***GetCommodityById***:", res);
            if (res.result) {
              var _data = res.data;
              if (_data['NewCommunityImages'] && _data['NewCommunityImages'].length) {
                _data['NewCommunityImages'] = _data['NewCommunityImages'].filter(function (item) {
                  if (item['ImageUrl']) {
                    return item
                  }
                })
              }
              that.FormData = { ...that.FormData, ..._data };
              that.$set(that.FormData, "DraftId", that.DraftId);
              if (_data["PropertyJson"]) {
                that.tempPropertyJson = {
                  ...that.tempPropertyJson,
                  ..._data["PropertyJson"],
                };
              }
              that.priceExchange("USD"); //汇率转换 rmb->usd
              that.CardEdit(); //商品编辑
              that.ExcludedReSet(); //运费重排及去除type3、4
              console.log("CardDetail-FormData", that.FormData);
            }
          };
          that.$get(api, data).then((res) => {
            console.log("axios-res:", api, res);
            fun(res);
          })
            .catch((err) => { console.log(err); });
          break;
        case 'GetNewCommodityByCode'://根据验货报告Code获取卡片信息
          fun = function (res) {
            //console.log("***GetNewCommodityByCode***:", res);
            if (res.result) {
              var _data = res.data;
              if (_data['PropertyJson']) {
                if (_data['ThirdCategoryId']) {
                  that.getData('GetCommodityTitleRuleByThirdCategoryId', `?ThirdCategoryId=${_data['ThirdCategoryId']}`, '', 'ctgChange');
                }
                that.$set(that.FormData, 'PropertyJson', _data['PropertyJson'])
                that.$set(that.FormData, 'FirstCategoryId', _data['FirstCategoryId'])
                that.$set(that.FormData, 'FirstCategoryName', _data['FirstCategoryName'])
                that.$set(that.FormData, 'SecondCategoryId', _data['SecondCategoryId'])
                that.$set(that.FormData, 'SecondCategoryName', _data['SecondCategoryName'])
                that.$set(that.FormData, 'ThirdCategoryId', _data['ThirdCategoryId'])
                that.$set(that.FormData, 'ThirdCategoryName', _data['ThirdCategoryName'])
                that.$set(that.FormData, 'Title', _data['Title'])
                that.$set(that.FormData, 'SolrTitle', _data['SolrTitle'])
                setTimeout(function () {
                  that.CardEdit('rating');//商品编辑
                }, 1500)
              } else {
                that.$message({
                  message: '评级卡信息获取失败',
                  type: 'warning'
                });
              }
            } else { }
          }
          that.$get(api, data).then((res) => {
            console.log("axios-res:", api, res);
            fun(res);
          }).catch((err) => { console.log(err); });
          break;
        default:
          break;
      }
    },

    /* FormData 监听，步骤状态
     * 0:完成，1：未完成，2：无内容
     详情 DetailsSteps */
    FormDataWatch(type) {
      var that = this;
      var fd = that.FormData;
      // console.log("FormDataWatch:", type, fd);
      var _PropertyList = this.PropertyList;
      // console.log("watch-watch-watch:", _PropertyList);
      if (_PropertyList && _PropertyList.length) {
        var _CustomVal = this.FormData["CustomVal"] ? 1 : 0; //自定义(非必填)
        var _Description = this.FormData["Description"] ? 1 : 0; //描述(非必填)
        //console.log("深度监听_PropertyList", _PropertyList);
        var ckLeng = 0, //详情必填已填个数（属性0）
          ckLAll = 0, //详情必填项 个数（属性必填个数+自定义+描述）
          allLength = _CustomVal + _Description; //详情已填个数（包括非必填）
        _PropertyList.map(function (obj, key) {
          var ctlName = obj["ControlName"];
          var r = obj["IsRequired"].split("-")[0] == "1" ? true : obj["IsRequired"].split("-").length > 1 ? fd[obj["IsRequired"].split("-")[0]] == obj["IsRequired"].split("-")[1] && obj["IsRequired"].split("-")[2] == "1" ? true : false : false;
          if (r && obj["ControlType"] == "combox-more") {
            ctlName = ctlName + "Arr"; //多选必填项名称
          }
          if (fd[ctlName] && fd[ctlName].length > 0) {
            allLength += 1; //详情已填个数（包括非必填）
          }
          if (r) {
            ckLAll += 1; //属性必填项个数
          }
          if (fd[ctlName] && fd[ctlName].length > 0 && r) {
            ckLeng += 1; //属性必填项 已填个数
          }
        });
        // console.log(ckLAll, ckLeng, allLength)
        if (ckLeng <= 0 && allLength <= 0) {
          //均未填
          this.DetailsSteps = 2;
        } else if (ckLAll <= 0) {
          //属性无必填项
          that.DetailsSteps = 0;
        } else if (allLength > 0 && ckLeng <= 0) {
          //非必填已填，必填未填
          this.DetailsSteps = 1;
        } else if (allLength > 0 && ckLeng < ckLAll) {
          //必填未全填(如需必填全填此else if替换以下else if)
          this.DetailsSteps = 1;
        }
        //else if (ckLeng > 0) {
        //    that.DetailsSteps = 0;// 必填>=1
        //}
        else {
          that.DetailsSteps = 0;
        }
        if (that.PropertyIsRequiredLeng <= 0 && _CustomVal) {
          //无必填属性，当自定义填写时的状态
          that.DetailsSteps = 0;
        }
      }

      /* 定价 */
      var bw = fd["ByWay"];
      var ReleaseType = fd["ReleaseType"]; /*时间方式*/
      var LastOnTime = fd["LastOnTime"]; /*上架时间 ReleaseType=1*/
      var QuantitySold = fd["QuantitySold"]; //数量
      var price = fd["Price"]; /*商品价格*/
      var EffectiveDay = fd["EffectiveDay"]; /*有效期*/

      /* 计算截标时间 EffectiveDay LastOnTime */
      // console.log('计算截标时间', EffectiveDay, LastOnTime);CountEndTime

      // if (EffectiveDay && ReleaseType === 0) {
      //   /*当有有效期且立即上架时*/
      //   that.CountDownLastEndTime(ReleaseType, EffectiveDay, LastOnTime);
      // } else {
      //   /*当有有效期且具体上架时间*/
      //   clearInterval(that.CountEndTime);
      //   that.setLastEndTime(ReleaseType, EffectiveDay, LastOnTime);
      // }
      that.setLastEndTime(ReleaseType, EffectiveDay, LastOnTime);
      /* 计算截标时间ed */


      /* 如需必填全填以下注释if项替换下部if */
      if (bw == 2) {
        //拍卖
        var IsDeposit = fd["IsDeposit"]; /*是否保证金*/
        var DepositNum = fd["DepositNum"]; /*保证金金额*/
        var CreditNum = fd["CreditNum"]; /*信用金额*/
        var t1 = EffectiveDay && price && QuantitySold ? true : false;
        if (t1 && ReleaseType == 0 && IsDeposit == 0) {
          that.PricingSteps = 0;
        } else if (t1 && ReleaseType == 0 && IsDeposit == 1 && DepositNum && CreditNum) {
          that.PricingSteps = 0;
        } else if (t1 && ReleaseType == 1 && LastOnTime && IsDeposit == 0) {
          that.PricingSteps = 0;
        } else if (t1 && ReleaseType == 1 && LastOnTime && IsDeposit == 1 && DepositNum && CreditNum) {
          that.PricingSteps = 0;
        } else {
          that.PricingSteps = 1;
        }
      } else if (bw == 1) {
        //一口价
        var Bargain = fd["Bargain"]; /*是否议价*/
        var IsLimit = fd["IsLimit"]; /*是否限量*/
        var LimitNumber = fd["LimitNumber"]; /*限量数量*/
        var LPrice = fd["LPrice"]; /*低于该价格自动拒绝*/
        var HPrice = fd["HPrice"]; /*高于该价格自动接受*/
        var t2 = EffectiveDay && price && QuantitySold ? true : false;
        if (t2 && Bargain == 0 && ReleaseType == 0) {
          // && IsLimit == 0
          that.PricingSteps = 0;
        } else if (t2 && Bargain == 1 && LPrice && HPrice && ReleaseType == 0) {
          // && IsLimit == 0
          that.PricingSteps = 0;
        } else if (t2 && Bargain == 0 && ReleaseType == 0) {
          // && IsLimit == 1 && LimitNumber
          that.PricingSteps = 0;
        } else if (t2 && Bargain == 0 && ReleaseType == 1 && LastOnTime) {
          //&& IsLimit == 0
          that.PricingSteps = 0;
        } else if (t2 && Bargain == 1 && LPrice && HPrice && ReleaseType == 1 && LastOnTime) {
          //&& IsLimit == 0
          that.PricingSteps = 0;
        } else if (t2 && Bargain == 0 && ReleaseType == 1 && LastOnTime) {
          //&& IsLimit == 1 && LimitNumber
          that.PricingSteps = 0;
        } else {
          that.PricingSteps = 1;
        }
      }
      //if ((bw && bw > 0) || (ReleaseType && ReleaseType >= 0) || (ReleaseType&&QuantitySold>0)) {
      //    that.PricingSteps = 0;//必填已填即蓝色
      //}
      else {
        that.PricingSteps = 2;
      }
      /* 运费 DomesticSteps */
      var CommunityPostages = fd["CommunityPostages"] || [];
      if (CommunityPostages) {
        if (CommunityPostages.length <= 0) {
          that.DomesticSteps = 2;
        } else {
          var dStep = 0;
          CommunityPostages.map(function (obj, k) {
            if (obj["AreaID"] == "") {
              dStep++;
            } else if (obj["Status"] <= 0) {
              dStep++;
            }
          });
          that.DomesticSteps = dStep >= 1 ? 1 : 0;
        }
      }
    },
    setLastEndTime(ReleaseType, EffectiveDay, LastOnTime) {
      /* 计算截标时间 EffectiveDay LastOnTime */
      var that = this;
      var _LastOnTime = ReleaseType == 1 ? LastOnTime : util.getTime("yyyy-MM-dd HH:mm:ss")
      if (EffectiveDay && _LastOnTime) {
        let endingList = that.$store.getters.stopBidsDate(EffectiveDay, _LastOnTime);
        that.endingList = endingList;
        that.ShowEndingList = true;
        // console.log('endingList', endingList)
      } else {
        that.endingList = [];
        that.ShowEndingList = false;
      }
    },
    CountDownLastEndTime(ReleaseType, EffectiveDay, LastOnTime) {
      var that = this;
      that.CountEndTime = setInterval(function () {
        that.setLastEndTime(ReleaseType, EffectiveDay, LastOnTime)
      }, 1000);
    },
    ifStartTime() {
      var that = this;
      var CardStartTime = that.$store.state.CardStartTime || "";
      if (CardStartTime) {
        var newTime = util.setNewDate(CardStartTime);
        var CGMT = new Date(newTime);
        var addSeconds = CGMT.setSeconds(CGMT.getSeconds() + 30); //发布并继续录入时 定时上架时间往后挪三十秒
        var newDate = util.getTime("yyyy-MM-dd HH:mm:ss", addSeconds);
        that.StartTime = newDate;
        that.$set(that.FormData, "LastOnTime", newDate);
        that.$set(that.FormData, "ReleaseType", 1);
        //console.log(CardStartTime, CGMT, addSeconds, util.getTime("yyyy-MM-dd HH:mm:ss", addSeconds));
      }
      //console.log("that.FormData.", that.FormData, that.StartTime);
    },
    ClearCardStartTime() {
      this.$store.state.CardStartTime = "";
    },
    setDefaultCtg() {
      var that = this;
      var _data = that.Categories;

      that.$set(that.tempFormData, 'FirstCategoryId', _data[0]['id'])//分类-1级ID
      that.$set(that.tempFormData, 'FirstCategoryName', _data[0]['EnName'])//分类-1级Name
      that.$set(that.tempFormData, 'FirstCategoryNameCh', _data[0]['ChName'])//分类-1级ChName
      that.$set(that.tempFormData, 'SecondCategoryId', _data[0]['children'][0]['id']);//分类-2级Id
      that.$set(that.tempFormData, 'SecondCategoryName', _data[0]['children'][0]['EnName']);//分类-2级Name
      that.$set(that.tempFormData, 'SecondCategoryNameCh', _data[0]['children'][0]['ChName']);//分类-2级ChName
      that.$set(that.tempFormData, 'ThirdCategoryId', _data[0]['children'][0]['children'][0]['id']);//分类-3级Id
      that.$set(that.tempFormData, 'ThirdCategoryName', _data[0]['children'][0]['children'][0]['EnName']);//分类-3级Name
      that.$set(that.tempFormData, 'ThirdCategoryNameCh', _data[0]['children'][0]['children'][0]['ChName']);//分类-3级ChName

      that.$set(that.FormData, 'FirstCategoryId', _data[0]['id'])//分类-1级ID
      that.$set(that.FormData, 'FirstCategoryName', _data[0]['EnName'])//分类-1级Name
      that.$set(that.FormData, 'FirstCategoryNameCh', _data[0]['ChName'])//分类-1级ChName
      that.$set(that.FormData, 'SecondCategoryId', _data[0]['children'][0]['id']);//分类-2级Id
      that.$set(that.FormData, 'SecondCategoryName', _data[0]['children'][0]['EnName']);//分类-2级Name
      that.$set(that.FormData, 'SecondCategoryNameCh', _data[0]['children'][0]['ChName']);//分类-2级ChName
      that.$set(that.FormData, 'ThirdCategoryId', _data[0]['children'][0]['children'][0]['id']);//分类-3级Id
      that.$set(that.FormData, 'ThirdCategoryName', _data[0]['children'][0]['children'][0]['EnName']);//分类-3级Name
      that.$set(that.FormData, 'ThirdCategoryNameCh', _data[0]['children'][0]['children'][0]['ChName']);

      that.tempProperties = _data[0]['children'][0]['children'][0]['Properties'];//获取3级内属性列表CategoryProperties
    },
    SetGraderTitle: function (data, type) {
      var that = this;
      var _FormData = that.FormData;
      var rarity = data.Rarity ? (data.Rarity + ' ') : '';//TCG罕贵度
      var numb = data.CardNumber ? (data.CardNumber.indexOf("#") > -1 ? (data.CardNumber + ' ') : ("#" + data.CardNumber + ' ')) : '';//卡编
      var profess = data.ProfessionalGrader ? data.ProfessionalGrader : '';//评级公司
      var parallelVariety = data.ParallelVariety ? (data.ParallelVariety + ' ') : '';//平行/折射
      profess = profess == 'GBTC' ? '公博' : profess;
      var Grade = data.Grade ? data.Grade : '';//评分

      // #宝可梦 版本简称、卡片编号
      var cardCode = data.Set_code ? (data.Set_code + ' ') : '';
      var cardNumb = data.Card_number ? (data.Card_number.replace(/#/g, '') + ' ') : '';
      var numb_code = cardCode + cardNumb;
      // #end
      var np = `${numb_code + parallelVariety + numb + rarity + (profess ? profess + Grade : '')}`;//#123 PSA10
      np = np.trim();

      if (type == 'rating' || type == 'ai') {
        var _CustomVal = _FormData['CustomVal'];
        _CustomVal = _CustomVal.trim();
        if (_CustomVal.indexOf(np) <= -1) {
          if (that.oldNp && that.oldNp != np) {
            _CustomVal = _CustomVal.replace(that.oldNp, '');
          }
          that.oldNp = np;
          _CustomVal = _CustomVal ? (that.isVip == 'true' ? (_CustomVal + " " + np) : (np + " " + _CustomVal)) : np;
          that.$set(that.FormData, 'CustomVal', _CustomVal);
        }
      } else {
        that.oldNp = np;
      }
    },
    CardEdit(type) {
      var that = this;
      //商品编辑
      var _FormData = that.FormData;
      var _PropertyJson = _FormData["PropertyJson"];
      var _Description = _FormData["Description"];
      var decodePropertyJson = {};
      if (_PropertyJson) {
        decodePropertyJson = JSON.parse(decodeURIComponent(_PropertyJson));
        // console.log('######',decodePropertyJson);
        that.tempPropertyJson = decodePropertyJson;
        that.FormData = { ...that.FormData, ...decodePropertyJson };
        that.$set(that.FormData, "PropertyJson", "");
        //that.FormData = { ...that.FormData };
        //for (var key in decodePropertyJson) {
        //    this.$set(this.FormData, key, decodePropertyJson[key]);
        //}
        // console.log("decodePropertyJson",that.FormData, decodePropertyJson, JSON.parse(decodeURIComponent(_PropertyJson)));
      }
      if (_Description) {
        var des = '';
        try {
          des = decodeURIComponent(_Description);
        } catch (err) {
          des = _Description;
        } finally { }
        editor.txt.html(des);
        //that.$set(that.FormData, 'Description', _Description)
      }
      if (_FormData["Title"] && that.isVip == 'true') {
        //VIP自定义部分即标题
        that.$set(that.FormData, 'CustomVal', _FormData['Title']);
        that.titleShow = true;//生成标题（显示）
        that.CustomInput();//重新验证CustomVal
      }
      //console.log("NewCommunityImages:", this.FormData['NewCommunityImages']);
      if (this.FormData["NewCommunityImages"] && this.FormData["NewCommunityImages"].length) {
        that.picList = _FormData["NewCommunityImages"]; //图片显示
        //that.setPic2Form();
      }
      if (_FormData["LPrice"]) {
        that.minPrice = true;
      }
      if (_FormData["HPrice"]) {
        that.autoPrice = true;
      }
      if (_FormData["LastOnTime"]) {
        // let sTime = that.$store.state.timeZone != "+08" ? that.$store.getters.getTime(_FormData['LastOnTime'], -8, 'cmtNull', 'YYYY-MM-DD HH:mm:ss', 'cn') : _FormData['LastOnTime'];
        let sTime = that.$store.getters.getTime(_FormData["LastOnTime"], that.$store.state.lang.indexOf("zh") > -1 ? 8 : -8, "cmtNull", "YYYY-MM-DD HH:mm:ss");
        that.StartTime = sTime;
      }

      if (type == 'rating' || type == 'ai') {
        //评级卡快速录入
        //写卡片编号和评级公司
        that.SetGraderTitle(decodePropertyJson, type)
      }

      ////////////tempFormData///////////
      /*
      FirstCategoryId FirstCategoryName,SecondCategoryId SecondCategoryName,ThirdCategoryId ThirdCategoryName
      */
      that.ctgKeyList.forEach(function (item, k) {
        that.$set(that.tempFormData, item, _FormData[item] || '');
      })
      ////////////tempFormData///////////
      /** find categoryProperties **/
      var ctgs = that.Categories, fid = _FormData["FirstCategoryId"], sid = _FormData["SecondCategoryId"], tid = _FormData["ThirdCategoryId"];
      //console.log("----------", ctgs, fid, sid, tid);
      ctgs.forEach(function (o, k) {
        if (o['id'] == fid) {
          //console.log("category****", o, o['FirstCategory']['Category']['ChName']);
          that.ctgIndex = k;
          that.$set(that.tempFormData, 'FirstCategoryNameCh', o['ChName']);//分类-1级ChName
          that.$set(that.FormData, 'FirstCategoryNameCh', o['ChName']);//分类-1级ChName
          o['children'].forEach(function (oo, kk) {
            //console.log("category**secondCategories**", oo);
            if (oo['id'] == sid) {
              that.$set(that.tempFormData, 'SecondCategoryNameCh', oo['ChName']);//分类-2级ChName
              that.$set(that.FormData, 'SecondCategoryNameCh', oo['ChName']);//分类-2级ChName
              that.sCtgIndex = kk;
              oo['children'].forEach(function (ooo, kkk) {
                if (ooo['id'] == tid) {
                  that.tCtgIndex = kkk;
                  that.$set(that.tempFormData, 'ThirdCategoryNameCh', ooo['ChName']);//分类-2级ChName
                  that.$set(that.FormData, 'ThirdCategoryNameCh', ooo['ChName']);//分类-2级ChName
                  var _categoryProperties = ooo['Properties'];
                  that.ReSetProperties(_categoryProperties);
                  that.cur = [k, kk, kkk];
                  //console.log("xxxxx", tid, that.tempFormData['ThirdCategoryId'], _categoryProperties, that.cur);
                  return
                }
              })
            }
          });
        }
      });
      /** find categoryProperties、、、 **/

      that.ctgShow = true;

      setTimeout(function () {
        that.FormDataWatch(2);
        if (_FormData["Title"]) {
          //编辑旧商品属性不匹配
          that.titleShow = that.DetailsSteps == 0 || that.PropertyIsRequiredLeng <= 0 ? true : false;
        }
      }, 1000);
      if (!that.FormData["ThirdCategoryId"]) {
        //老卡
        that.setDefaultCtg();
        that.CtgYes(true);
        that.$set(that.FormData, "Title", "");
        that.$set(that.FormData, "SolrTitle", "");
      }
      that.setCardTitle('CardEdit');
      console.log("商品编辑FormData:", that.FormData);

      that.showMorePro = true;
      if (that.clone) {
        if (!that.oldNp) {
          that.SetGraderTitle(decodePropertyJson, 'clone')
        }
        var cloneType = type == 'rating' || type == 'ai' ? 'newRating' : 'cloneOnce';
        if (type != 'ai') {
          that.cardClone(cloneType);
        }
      }
      //console.log("商品编辑tempPropertyJson:", that.tempPropertyJson);
    },
    cardClone: function (type) {
      var that = this;
      //console.log('cardClonecardClonecardClone');
      that.picList = [];
      that.$set(that.FormData, "NewCommunityImages", []);
      // console.log("ByWay", that.FormData["PriceMyUsd"]);
      if (that.FormData["ByWay"] == 1) {
        //that.$set(that.FormData, 'Price', null);
        that.$set(that.FormData, "Bargain", null);
        //发布相似 起始价 0.99
        if (that.FormData["PriceMyUsd"] < 0.99) {
          that.$set(that.FormData, "Price", that.$store.getters.priceExchange(0.99, "")); /* 拍卖->价格=1 */
          that.$set(that.FormData, "PriceMyUsd", 0.99); /* 拍卖->价格=1 */
        }
      } else {
        //竞拍 起始价 0.99
        that.$set(that.FormData, "Price", that.$store.getters.priceExchange(0.99, "")); /* 拍卖->价格=1 */
        that.$set(that.FormData, "PriceMyUsd", 0.99); /* 拍卖->价格=1 */
      }

      that.$set(that.FormData, "LastOnTime", "");
      that.StartTime = "";
      that.$set(that.FormData, "ReleaseType", 0);
      that.$set(that.FormData, "QuantitySold", 1);
      if (type == 'cloneOnce') {
        that.$set(that.FormData, 'ProfessionalGrader', '');//评级公司
        that.$set(that.FormData, 'Grade', '');//评级分数
        that.$set(that.FormData, 'CertificationNumber', '');//证书编号
        that.$set(that.FormData, 'CardNumber', '');//卡片编号
        //that.$set(that.FormData, 'ParallelVariety', '');//平行/折射

        that.$set(that.tempPropertyJson, 'ProfessionalGrader', '');//评级公司
        that.$set(that.tempPropertyJson, 'Grade', '');//评级分数
        that.$set(that.tempPropertyJson, 'CertificationNumber', '');//证书编号
        that.$set(that.tempPropertyJson, 'CardNumber', '');//卡片编号
      }
    },
    setCategories2: function (obj, key) {
      var that = this;
      var key = key.split("-");
      that.ctgIndex = key[0] || 0;
      that.sCtgIndex = key[1] || 0;
      that.tCtgIndex = key[2] || 0;
      var _cur = [key[0], key[1] || 0, key[2] || 0];
      that.cur = _cur;
      if (key.length < 3) {
        //点击1、2级时默认第3级第一个
        obj = that.Categories[_cur[0]]['children'][_cur[1]]['children'][_cur[2]];
      }
      //console.log("setCategories2", key, that.cur, obj);

      that.$set(that.tempFormData, 'FirstCategoryId', (obj.level == 1 ? obj.id : (obj.fId || '')));//分类-1级ID
      that.$set(that.tempFormData, 'FirstCategoryName', (obj.level == 1 ? obj.EnName : (obj.FEName || '')));//分类-1级Name
      that.$set(that.tempFormData, 'FirstCategoryNameCh', (obj.level == 1 ? obj.ChName : (obj.FCName || '')));//分类-1级ChName 

      that.$set(that.tempFormData, 'SecondCategoryId', (obj.level == 2 ? obj.id : (obj.sId || '')));
      that.$set(that.tempFormData, 'SecondCategoryName', (obj.level == 2 ? obj.EnName : (obj.SEName || '')));
      that.$set(that.tempFormData, 'SecondCategoryNameCh', (obj.level == 2 ? obj.ChName : (obj.SCName || '')));

      that.$set(that.tempFormData, 'ThirdCategoryId', (obj.level == 3 ? obj.id : (obj.tId || '')));
      that.$set(that.tempFormData, 'ThirdCategoryName', (obj.level == 3 ? obj.EnName : (obj.TEName || '')));
      that.$set(that.tempFormData, 'ThirdCategoryNameCh', (obj.level == 3 ? obj.ChName : (obj.TCName || '')));

      that.tempProperties = obj.Properties || [];//获取3级内属性列表
      // that.$nextTick(function () {
      //   // console.log("xxxxxxx", that.tempFormData, that.tempProperties);
      // })
    },
    /*属性列表自定义筛选*/
    remoteMethod(query, ctlName, item) {
      //console.log('remoteMethod:', query, ctlName, item);
      if (query !== "") {
        this.sltloading = true;
        setTimeout(() => {
          this.sltloading = false;
          if (item["select"]) {
            let filterSlt = item["select"].filter((item) => {
              let obj = item["ChName"].indexOf(query.toLowerCase()) > -1 || item["EnName"].toLowerCase().indexOf(query.toLowerCase()) > -1 || item["OtherName"].toLowerCase().indexOf(query.toLowerCase()) > -1;
              return obj;
            });
            this.$set(this.PropertySelectList, ctlName, filterSlt);
          }
        }, 100);
      } else {
        this.sltloading = false;
        if (item["select"]) {
          let filterSlt = item["select"].slice(0, this.PropertySelectDefaultShow);
          this.$set(this.PropertySelectList, ctlName, filterSlt);
        }
      }
    },
    /*单选按钮*/
    switchBtn(event, item, key, ControlName) {
      var that = this;
      console.log('switchBtn:', event, item, key, ControlName);
      if (item["select"]) {
        that.setChangeVal(event, item, "", item, key);
      } else {
        let cFun = function () {
          that.setChangeVal(event, item, "", item, key);
        };
        that.getData("GetKeyValue", "?propertyId=" + item["_id"], key, ControlName, cFun);
      }
    },
    /*输入框*/
    inputChange(e) {
      //解决类目切换输入框无法输入
      this.$forceUpdate(e);
    },
    /*属性列表选中赋值*/
    setChangeVal(event, slt, type, item, key, isClickChange) {
      var that = this;
      // console.log('setChangeVal:', event, slt, type, item, key, typeof event);
      var objType = typeof event;
      //var _show = name == 'ProfessionalGrader' || name == 'Grade' || name == 'Quantity' ? false : true;
      var sltName = "";
      if (type == "blur") {
        //文本
        var obj = event, key = slt;
        var name = obj["ControlName"];
        that.$set(that.tempPropertyJson, name, that.FormData[name]); //输入框值写入tempPropertyJson[属性值独立]
        //console.log('setChangeValsetChangeVal:', obj['name'], key, type, that.FormData[obj['name']]);
      } else if (type == "multiple") {
        //console.log('that.setChangeVal:', event, slt, type);
        sltName = slt;
        that.$set(that.FormData, sltName, event); //下拉选项值写入FormData
        that.$set(that.tempPropertyJson, sltName, event); //输入框值写入tempPropertyJson[属性值独立]
        //console.log("that.FormData[FeaturesArr]::", that.FormData[sltName]);
      } else {
        sltName = slt["ControlName"];
        if (objType == "object") {
          var sltValue = event["EnName"]; //单项列表
          var sltDataAll = {
            // 下拉选项全部值
            chName: event["ChName"] || "", enName: event["EnName"] || "", otherName: event["OtherName"] || "",
          };
        } else {
          var sltValue = event.trim(); //单项列表 自定义值
          var sw = {};
          try {
            slt["select"].filter((obj, k) => {
              if (obj["EnName"] == event) { sw = obj; }
            });
          } catch (error) {

          }
          // console.log(sw);
          var sltDataAll = {
            // 下拉选项全部值 自定义值
            chName: sw["ChName"],
            enName: sw["EnName"],
            otherName: sw["OtherName"],
          };
        }
        //that.tempSelectData = {
        //    'name': sltName,
        //    'data': sltDataAll
        //};
        // console.log('setChangeVal.FormData,sltName,sltValue,sltDataAll:', that.FormData, sltName, sltValue, sltDataAll);
        that.$set(that.tempSelectData, sltName, sltDataAll); //下拉选项全部值 SolrTitle
        that.$set(that.FormData, sltName, sltValue); //下拉选项值写入FormData
        that.$set(that.tempPropertyJson, sltName, sltValue); //下拉选项值写入tempPropertyJson[属性值独立]

        switch (sltName) {
          //case 'Graded'://是否评级 清除 评级公司 评级分数
          //    if (sltValue == "No") {
          //        that.$set(that.FormData, 'ProfessionalGrader', '');
          //        that.$set(that.FormData, 'Grade', '');
          //    }
          //    break;
          //case 'Limited'://是否限量 清除 限量数量
          //    if (sltValue == "No") {
          //        that.$set(that.FormData, 'LimitQuantity', '');
          //    }
          //    break;
          default:
            break;
        }
      }
      var _isClickChange = isClickChange ? isClickChange : ''
      that.setCardTitle("click", sltName, '', _isClickChange); //组标题
    },
    /*点击按钮生成标题*/
    GenerateTheTitle() {
      var that = this;
      let ts = !this.titleShow;
      if (this.DetailsSteps == 0) {
        this.titleShow = ts;
      }
      if (ts) {
        that.setCardTitle();
        that.$set(that.FormData, "Title", that.FormData["CustomVal"]); //商品标题 写入FormData 提交用
        //that.$set(that.FormData, 'Title', that.TitleTemp); //商品标题 写入FormData 提交用
        // that.$set(that.FormData, 'SolrTitle', that.SolrTitleTemp);//商品标题 写入FormData 提交用
      } else {
        that.$set(that.FormData, "Title", "");
        // that.$set(that.FormData, 'SolrTitle', "");
        //that.$set(that.FormData, 'CustomVal', "");
      }
      //this.titleShow = !this.titleShow;
    },
    ShowMore() {
      this.showMorePro = !this.showMorePro
    },
    /*
     ** 球星卡： 厂商、系列、球员
     ** 娱乐卡： 影视名称、厂商、演员
     ** TCG： 游戏名称、序列、语言版本
     ** 手绘： 主题、厂商、角色名称、画师
     */
    setPropertyValue(obj, val, key) {
      let that = this;
      if (that.FormData["SecondCategoryName"] != "CardFun" && that.FormData["ThirdCategoryName"] == "Trading Card Singles" && obj["IsRequired"] != "0") {
        let IstempPropertyData = {
          propertyId: obj["_id"],
          propertyChName: obj["ChName"],
          propertyEnName: obj["EnName"],
          ControlName: obj["ControlName"],
          keyValue: val,
        };
        that.tempPropertyData.unshift(IstempPropertyData);
      }
      //console.log('type, val, key-',type, val, key)
    },
    /*生成标题 - 组标题*/
    setCardTitle(type, sltName, ele, isClickChange) {
      var that = this;
      //组标题  *****不能含有中文******
      var _FormData = that.FormData;
      var _tempSelectData = that.tempSelectData;
      //console.log("setCardTitle", type, sltName);
      var cardType = _FormData['SecondCategoryId'];
      var ThirdCategoryName = _FormData['ThirdCategoryName'];
      var _title = '', _solrTitle = '';
      var _CustomVal = that.FormData['CustomVal'] ? that.FormData['CustomVal'] : '';//自定义

      var ttType = util['cardType']['getType'](ThirdCategoryName);
      var _titleRule = that.titleRule.length > 0 ? that.titleRule : util.solrTitle(cardType, "", ttType);//取接口标题规则 //util.solrTitle(cardType, "", ttType);//自定义规则

      /* 组title 、solrtitle */
      var FormSolrTitle = that.FormData['SolrTitle'];
      var FormSolrTitleArr = FormSolrTitle.split("|");
      var tempPropertyJson = that.tempPropertyJson;
      //console.log("FormSolrTitleArr:", _titleRule, FormSolrTitle);
      var PropertyJsonTitle = ''
      _titleRule.map(function (obj, k) {
        //原始json，所组的title（除Rookie，CustomVal）
        if (obj != 'Rookie' && obj != 'CustomVal') {
          PropertyJsonTitle += tempPropertyJson[obj] + ' ';
        }
      });
      PropertyJsonTitle = PropertyJsonTitle.trim()
      var reSetSolrTitle = function (editObj) {
        var val = "";
        /* SolrTitle 遍历验证是否存在， */
        _titleRule.filter(function (obj, k) {
          if (obj == editObj) {
            // console.log("obj:", obj, k, " ,tempPropertyJson:", tempPropertyJson[obj], " ,FormSolrTitleArr:", FormSolrTitleArr[k]);
            if (tempPropertyJson[obj] != undefined && FormSolrTitleArr[k] && FormSolrTitleArr[k].indexOf(tempPropertyJson[obj]) > -1 && obj != 'CustomVal') {
              /* SolrTitle 存在，保留原始值 */
              if (['Year'].indexOf(obj) > -1) {
                //无cnName otName直接替换
                val = tempPropertyJson[obj];
              } else if (['Rookie'].indexOf(obj) > -1) {
                //Rookie
                val = tempPropertyJson[obj] == 'Yes' || tempPropertyJson[obj] == '是' ? '新秀 Yes RC Rookie Card' : 'No';
              } else {
                //保留原始值 (除含特殊字符串)
                //var exclude = ['undefined', '【', '】'];// "~`!@#$%^&*()_+-=[]|{};':\",.<>?/「」【】";//规定的特殊字符，可以自己随意添加
                var fd = isClickChange && obj == sltName ? tempPropertyJson[obj] : FormSolrTitleArr[k]; //FormSolrTitleArr[k];
                if (PropertyJsonTitle.length && fd.indexOf(PropertyJsonTitle) > -1) {
                  fd = tempPropertyJson[obj]
                }
                val = fd.indexOf('undefined') > -1 || that.exclude2.test(fd) ? tempPropertyJson[obj] : fd;
              }
            } else {
              /* SolrTitle 不存在，属性值代入 */
              if (obj == 'CustomVal') {
                val = _CustomVal;
              } else {
                val = tempPropertyJson[obj];
              }
            }
          }
        });
        return val;
      }
      //console.log('_tempSelectData_tempSelectData', type, sltName, cardType, util['cardType']['level'][0]);
      var arrayTitle = [];
      var arraySolrTitle = [];
      _titleRule.map(function (obj, k) {
        var val = '';
        if (['Rookie'].indexOf(obj) > -1) {
          val = _FormData['Rookie'] == 'Yes' ? 'RC' : '';
        } else {
          val = _FormData[obj] ? _FormData[obj] : '';
        }
        arrayTitle.push(val);

        var solrVal = '';
        //console.log("arraySolrTitle", obj, k)
        if (obj == 'Rookie') {
          solrVal = _FormData['Rookie'] && _FormData['Rookie'] == 'Yes' ? '新秀 Yes RC Rookie Card' : '';
        } else if (that.allowCreateTitle.indexOf(obj) > -1) {
          //允许自定义的属性获取 选项 或 自定义
          solrVal = _tempSelectData[obj] && _tempSelectData[obj]['enName'] ? _tempSelectData[obj]['chName'] + " " + _tempSelectData[obj]['enName'] + " " + _tempSelectData[obj]['otherName'] : reSetSolrTitle(obj);
        } else {
          solrVal = _tempSelectData[obj] ? _tempSelectData[obj]['chName'] + " " + _tempSelectData[obj]['enName'] + " " + _tempSelectData[obj]['otherName'] : reSetSolrTitle(obj);
        }
        arraySolrTitle.push(solrVal);
      });

      _title = arrayTitle.join('|');///////_title/////////
      //console.log("_title_title", _title);
      _solrTitle = arraySolrTitle.join('|');//////_solrTitle//////
      //console.log('new_solrTitle', _solrTitle)
      /* 组solrtitle */

      var __title = _title.trim().split("|");//标题显示 array型 split‘|’

      __title = __title.filter(function (obj, k) {//标题获取及显示 排除‘自定义’，自定义单独一行显示
        if (k < __title.length - 1) { return obj; }
      });

      var _proLength = 0;
      var _title_no_line = "";
      that.cardTitle = __title.filter(function (obj, k) {
        //显示用，遍历去除空字段
        if (obj) {
          _proLength += obj.length;
          _title_no_line += obj + (k < __title.length - 1 ? " " : "")
          return obj
        }
      });
      if (that.cardTitle.length > 0) {
        /* 标题长度添加字段间隔1 */
        _proLength += that.cardTitle.length - 1;
      }

      var _titleLength = 0;
      if (that.isVip == 'true') {
        _titleLength = (_CustomVal.length ? _CustomVal.length : 0);
      } else {
        var title_more = _proLength > 0 ? 1 : 0;//有标题规则自定义部分+1（空格）
        _titleLength = (_CustomVal.length ? _CustomVal.length + title_more : 0) + _proLength;//titleMax:总数
      }

      /* 生成标题 - 临时  */
      var ttNoLine = _title_no_line.length > 0 ? _title_no_line : "";
      //var titleAll = _title.replace("|", " ");
      that.TitleTemp = ttNoLine;
      //that.TitleTempAll = titleAll;
      that.SolrTitleTemp = _solrTitle;

      //if (type == 'CardEdit') {
      //    _CustomVal = _FormData['Title'].replace(ttNoLine, "")
      //}
      //console.log("xxxx", type, _FormData['Title'], ' *****', _solrTitle);
      if (type == 'CardEdit' && _FormData['Title'] && _CustomVal != _FormData['CustomVal'] && _CustomVal == '') {
        //自定义为空且有标题时，根据原标题和重组标题（无自定义）截取自定义部分
        //console.log("自定义标题：：：",_FormData['Title'],' ## ', ttNoLine);
        var sbCV = _FormData['Title'].indexOf(ttNoLine) > -1 ? _FormData['Title'].replace(ttNoLine, '') : _FormData['Title'];
        _CustomVal = that.isVip == 'true' ? _FormData['Title'] : sbCV.trim();
        _solrTitle += _CustomVal;

        that.titleShow = true;//生成标题（显示）
      }

      that.$set(that.FormData, 'CustomVal', _CustomVal);//自定义写入FormData  _CustomVal.trim()

      /* 生成标题  */
      that.$set(that.FormData, 'SolrTitle', _solrTitle);//商品标题 写入FormData 提交用

      var ttNoLineCv = ttNoLine + (_CustomVal ? " " + _CustomVal : "");
      if (that.isVip == 'true') {
        that.$set(that.FormData, 'Title', _CustomVal);//商品标题 写入FormData 提交用
      } else {
        that.$set(that.FormData, 'Title', ttNoLineCv.trim());//商品标题 写入FormData 提交用
      }

      //that.SolrTitle = _solrTitle;//Solr搜索切词字段['SolrTitle']  ****中文、别名暂未获取****
      //console.log("SolrTitle:", that.FormData['SolrTitle'], util.solrTitle(cardType, sltName));
      that.titleLength = _titleLength;//标题长度 属性+自定义
      that.remain = (that.titleMax - (_proLength + 1)) >= 0 ? that.titleMax - (_proLength + 1) : 0;//标题剩余长度 remain:剩余

      that.Steps('Details')//step详情状态

      //console.log("that.setCardTitleeeee:", that.FormData['Title']," ##SolrTitle: ", that.FormData['SolrTitle']);
    },
    CtgSelectYes(bool) {
      var that = this;
      let isBool = bool;
      that.$nextTick(function () {
        that.ctgSelectShow = isBool;
        that.ctgErr = false;
      });
    },
    CtgItemYes(bool, bool2) {
      //注意弹框按钮
      var that = this;
      let isBool = bool;
      let isSelect = bool2;
      that.$nextTick(function () {
        that.ctgItemShow = isBool;
        if (isSelect != null) {
          that.ctgShow = isSelect;
          that.ctgSelectShow = true;
        }
      });
    },
    /*类目 - 点击确认*/
    CtgYes(bool, type) {
      var that = this;
      let isBool = bool;
      that.$nextTick(function () {
        if (!isBool && that.FormData["ThirdCategoryId"]) {
          //取消
          that.ctgShow = true;
          that.ctgSelectShow = false;
          //清空分类选中
          //that.cur = [-1, -1, -1];
          /*选中原始类目*/
          var fid = that.FormData["FirstCategoryId"], sid = that.FormData["SecondCategoryId"], tid = that.FormData["ThirdCategoryId"];
          //console.log(fid, sid, tid);
          that.Categories.forEach(function (o, k) {
            if (o['id'] == fid) {
              that.ctgIndex = k;
              that.$set(that.cur, 0, k);//1级选中样式
              that.$set(that.tempFormData, 'FirstCategoryId', o['id'])//分类-1级ID
              that.$set(that.tempFormData, 'FirstCategoryName', o['EnName'])//分类-1级Name
              that.$set(that.tempFormData, 'FirstCategoryNameCh', o['ChName'])//分类-1级ChName
              o['children'].forEach(function (oo, kk) {
                if (oo['id'] == sid) {
                  that.sCtgIndex = kk;
                  that.$set(that.cur, 1, kk);//2级选中样式
                  that.$set(that.tempFormData, 'SecondCategoryId', oo['id'])//分类-2级ID
                  that.$set(that.tempFormData, 'SecondCategoryName', oo['EnName'])//分类-2级Name
                  that.$set(that.tempFormData, 'SecondCategoryNameCh', oo['ChName'])//分类-2级ChName
                  oo['children'].forEach(function (ooo, kkk) {
                    if (ooo['id'] == tid) {
                      that.tCtgIndex = kkk;
                      that.$set(that.cur, 2, kkk);//3级选中样式
                      that.$set(that.tempFormData, 'ThirdCategoryId', ooo['id'])//分类-3级ID
                      that.$set(that.tempFormData, 'ThirdCategoryName', ooo['EnName'])//分类-3级Name
                      that.$set(that.tempFormData, 'ThirdCategoryNameCh', ooo['ChName'])//分类-3级ChName
                    }
                  });
                }
              });
            }
          });
          /*选中原始类目ed*/
        } else {
          //确定
          var _tempFormData = that.tempFormData;
          //console.log("_tempFormData['ThirdCategories']['_id']:", _tempFormData['ThirdCategoryId']);
          if (!_tempFormData['ThirdCategoryId']) {
            return false;
          }
          that.ctgShow = isBool;
          that.ctgSelectShow = false;
          /**点击确认 清空属性 表单 等*******/
          that.PropertySelectList = {};
          that.tempPropertyJson = {};
          var _pl = that.PropertyList;
          if (_pl.length) {
            var fd = that.FormData;
            _pl.filter(function (obj, key) {
              var ctlName = obj["ControlName"];
              if (fd[ctlName] != undefined) {
                //that.$set(that.FormData, ctlName,'');
                delete that.FormData[ctlName];
              }
            });
          }
          that.PropertyList = [];
          //that.FormData = {};
          that.tempSelectData = {};
          that.$set(that.FormData, "SolrTitle", "");
          that.$set(that.FormData, "Title", "");
          that.$set(that.FormData, "CustomVal", "");
          that.$set(that.tempFormData, "SolrTitle", "");
          that.$set(that.tempFormData, "Title", "");
          that.$set(that.tempFormData, "CustomVal", "");
          ///console.log("Yesssss", that.FormData);
          /**清空ed*******/
          if (_tempFormData['ThirdCategoryId']) {
            ///////
            if (type == 'ctgChange') {
              //收动改变类目，重现获取标题规则
              that.getData('GetCommodityTitleRuleByThirdCategoryId', `?ThirdCategoryId=${_tempFormData['ThirdCategoryId']}`, '', 'ctgChange');//获取标题规则
            }
            setTimeout(function () {

              that.$set(that.FormData, 'CategoriesId', _tempFormData['ThirdCategoryId'])

              that.ctgKeyList.forEach(function (item, k) {
                that.$set(that.FormData, item, _tempFormData[item]);
              })
              //console.log("_tempFormData['ThirdCategories']['_id']:", _tempFormData, _tempFormData['ThirdCategoryId'], that.FormData);
              //属性接口json，属性列表重组
              that.ReSetProperties(that.tempProperties, "newCtg");
            }, 500);
          }
          this.$nextTick(function () {
            that.titleShow = false;
            that.showMorePro = false;
            that.$refs.CreateCardForm.clearValidate(); //清除表单验证
            //console.log('New that.FormData', that.FormData)
          });
          if (that.Id == "" && that.DraftId == "" && type == "ctgChange") {
            //非编辑切换类目 清空表单
            that.ClearForm();
          }
          //切换类目 清空 自定义收集的表单
          that.PropertyData = [];
          that.tempPropertyData = [];
        }
      });
    },
    /*清空表单*/
    ClearForm() {
      var that = this;
      //that.$refs.CreateCardForm.resetFields(); //清除表单
      that.FormData["CustomVal"] = "";
      //that.FormData['Description'] = "";
      //editor.txt.html("");
    },
    /*属性列表重组*/
    ReSetProperties(categoryProperties, type) {
      /*
       * type:newCtg 重新选择类目
       */
      var that = this;
      //属性接口json，属性列表重组
      //console.log("categoryProperties---", categoryProperties)

      //var resetPro = util.resetProperties(categoryProperties);
      //that.tempPropertyJson = resetPro['tempPropertyJson'];
      //that.PropertyList = resetPro['propertyList'];

      //console.log("tempPropertyJson:", that.tempPropertyJson);
      //return false;

      var _tempPropertyJson = {};
      var _PropertyList = [];
      var _RequiredList = [];
      var _OtherList = [];
      var _allowCreateTitle = [];
      categoryProperties.map(function (obj, key) {
        var ctlName = obj['Property']['ControlName'];
        _tempPropertyJson[ctlName] = '';
        var _IsRequired = that.isVip == 'true' ? (that.VipProperty.indexOf(ctlName) > -1 && obj['IsRequired'] == "1" ? "1" : "0") : obj['IsRequired'];//必填必填必填
        var data = {
          "ControlType": obj['ControlType'],
          "IsRequired": _IsRequired,//必填必填必填
          "IsScreen": obj['IsScreen'],
          "Show": that.isVip == 'true' ? true : (obj['IsRequired'].length <= 1 ? true : false),
          ...obj['Property']
        };
        // console.log("_IsRequired", _IsRequired);
        if (_IsRequired == "1") {
          // 必填部分
          _RequiredList.push(data);
        } else {
          //非必填部分
          _OtherList.push(data);
        }
        if (obj['ControlType'].split('-').length >= 3 && obj['ControlType'].split('-')[2] == 'customize') {
          _allowCreateTitle.push(ctlName);//获取可自定义属性
        }
      });
      _PropertyList = _PropertyList.concat(_RequiredList).concat(_OtherList);//必填部分置前
      if (type) {
        that.tempPropertyJson = _tempPropertyJson;
        that.setCardTitle();
      }

      var PropertyListIsRequired = [], PropertyListEnRequired = [];
      _PropertyList.map(function (obj, key) {/*多选 数组化*/
        var ctlName = obj['ControlName'];
        if (obj['IsRequired'] == 1) { PropertyListIsRequired.push(obj) }
        else { PropertyListEnRequired.push(obj) }
        if (obj['ControlType'] == "switch") {
          var sw = that.tempPropertyJson[ctlName] ? that.tempPropertyJson[ctlName] : "No";
          that.$set(that.FormData, ctlName, sw);
          that.$set(that.tempSelectData, ctlName, { chName: sw, enName: sw, otherName: "", });//下拉选项全部值 SolrTitle
          that.$set(that.tempPropertyJson, ctlName, sw);//下拉选项值写入tempPropertyJson[属性值独立]
        }
        if (obj['ControlType'] == "combox-more" && that.FormData[ctlName] != undefined && that.FormData[ctlName] != '') {
          var ctlNameArr = obj['ControlName'] + 'Arr';
          var _Features = that.FormData[ctlName].split(",");
          that.$set(that.FormData, ctlNameArr, _Features);
          that.$set(that.tempPropertyJson, ctlNameArr, _Features);
        }
        if (key == _PropertyList.length - 1) {
          var CardEdit = !type && (that.Id || that.DraftId) ? 'CardEdit' : '';//是否属于编辑
          that.setCardTitle(CardEdit);
        }
      });
      var plrLeng = PropertyListIsRequired.length;
      that.PropertyIsRequiredLeng = plrLeng;
      // console.log("PropertyIsRequiredLeng", plrLeng)
      if (plrLeng <= 0) {
        //属性必填数为0时，显示自定义部分
        that.titleShow = true;
      }
      if (that.showMoreBtn) {
        var btnShowMore = {
          "ControlType": "ShowMoreBtn",
          "IsRequired": "0",
          "ChName": "更多",
          "EnName": "Show More"
        };
        // _PropertyList.splice(plrLeng, 0, btnShowMore);//添加更多按钮
        _PropertyList.push(btnShowMore);//添加更多按钮
      }
      if (that.isVip == 'false') {
        //非VIP 添加生成标题按钮
        var btnObj = {
          "ControlType": "PropertyBtn",
          "IsRequired": "0",
          "ChName": "标题",
          "EnName": "Title"
        };
        _PropertyList.splice(plrLeng, 0, btnObj);
      }
      setTimeout(function () {/**setTimeout解决单选、多选切换BUG**/
        that.PropertyList = _PropertyList;//重组后的属性列表
        that.allowCreateTitle = _allowCreateTitle;//可自定义的属性
        that.FormDataWatch(1);
        //console.log("allowCreateTitle .allowCreateTitle:", that.allowCreateTitle);
      }, 500);

    },
    /*运费方式*/
    ExcludedStatus(index) {
      var that = this;
      //console.log('ExcludedStatus, ', index, that.FormData['CommunityPostages'][index]);
      if (index != undefined) {
        var _CCP = that.FormData["CommunityPostages"][index];
        _CCP["Price"] = 0; //切换包邮 价格 0
        _CCP["PriceMyUsd"] = 0; //切换包邮 价格 0
        that.$set(that.FormData["CommunityPostages"], index, _CCP);
        that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
        that.Steps("Domestic");
      }
    },
    /*运费价格*/
    ExcludedPrice(index) {
      var that = this;
      //console.log('ExcludedPrice, ', index, that.FormData['CommunityPostages'][index]);
      if (index != undefined) {
        var _CCP = that.FormData["CommunityPostages"][index];
        _CCP["PriceMyUsd"] = parseFloat(_CCP["PriceMyUsd"]); //parseInt(_CCP['Price']);//int float
        console.log("####CommunityPostages####");
        that.priceExchange("", "CommunityPostages");
        that.$set(that.FormData["CommunityPostages"], index, _CCP);
        that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
        that.Steps("Domestic");
      }
    },
    /*添加、编辑区域弹框*/
    AddExcluded(index) {
      var that = this;
      that.tempArea = {};
      that.tempAreaArr = []; //清空临时显示区域
      if (index != undefined) {
        //编辑
        that.E_item = index;
        var _CommunityPostages = that.FormData["CommunityPostages"][index];
        if (_CommunityPostages["AreaID"] != "0") {
          //遍历已选区域
          var _areaIds = _CommunityPostages["AreaID"].split("、");
          var _areaNames = _CommunityPostages["AreaName"].split("、");
          var _ChinaArea = that.ChinaArea;
          var areaArr = [];
          _ChinaArea.map(function (obj, k) {
            obj["area"].map(function (ar, kk) {
              if (_areaIds.indexOf(ar["Code"]) >= 0) {
                var _name = `k-${k}-${kk}`;
                areaArr.push(_name);
                that.$set(that.tempArea, _name, ar);
              }
            });
          });
          that.tempAreaArr = areaArr;
          //遍历已选区域
        }
        that.CurCommunityPostages(); //获取已选区域
        //console.log("AddExcluded-find-tempArea-tempAreaArr", that.ChinaArea, that.tempArea, that.tempAreaArr);
      }
      that.dialogVisible = true;
    },
    /*区域弹框 点击选择区域*/
    selectArea(area, k, kk, type, disable) {
      var that = this;
      /*
       * tempArea 临时存储区域列表 {'k-0-1':{},'k-0-2':{}}
       * tempAreaArr 临时存储区域对应key ['k-0-1','k-0-2'] 第一层第index（0）个中的第index（1）个
       */
      //console.log(type);
      //that.tempArea = [...that.tempArea, { 'area': area, 'pk': k, 'ck': kk }];
      if (disable) {
        //已被选区域不可再选
        return false;
      }
      var _name = `k-${k}-${kk}`,
        value = "";
      if (that.tempArea[_name] == undefined || that.tempArea[_name] == "") {
        value = area;
      }
      if (type == "delt") {
        Array.prototype.remove = function (val) {
          var index = this.indexOf(val);
          if (index > -1) {
            this.splice(index, 1);
          }
        };
        that.tempAreaArr.remove(_name);
        if (that.curPostages.indexOf(area["Code"]) > -1) {
          that.curPostages.remove(area["Code"]);
        }
      } else {
        that.tempAreaArr.push(_name);
      }
      that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
      that.$set(that.tempArea, _name, value);
      //console.log("tempArea:", that.tempArea, "tempAreaArr:", that.tempAreaArr);
    },
    /*删除运费*/
    DelExcluded(index) {
      var that = this;
      if (index != undefined) {
        that.FormData["CommunityPostages"].splice(index, 1);
        that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
        that.CurCommunityPostages(); //获取已选区域
      }
    },
    /*区域选择 确认*/
    ExcludedYes() {
      var that = this;
      var _tempArea = that.tempArea, _tempAreaArr = that.tempAreaArr, _ChinaArea = that.ChinaArea;
      var aid = "", aname = "";
      _tempAreaArr.map(function (obj, key) {
        var areaKey = obj.split("-");
        var cArea = _ChinaArea[areaKey[1]]["area"][areaKey[2]];
        if (_tempArea[obj] && _tempArea[obj] != "") {
          aid += (key > 0 ? "、" : "") + cArea.Code;
          aname += (key > 0 ? "、" : "") + cArea.EName;
        }
      });
      if (that.E_item != "") {
        //编辑
        var index = that.E_item;
        var _CCP = that.FormData["CommunityPostages"][index];
        var _data = {
          AreaID: aid ? aid : "0",
          AreaName: aid ? aname : that.$t('newItem.domesticShipping'),
          Status: _CCP["Status"], //1是包邮，2是顺丰到付，3是自定义价格
          Price: _CCP["Price"], //Status 3 自定义价格
          PriceMyUsd: _CCP["PriceMyUsd"], //Status 3 自定义价格
          Type: aid ? 2 : 1, //_CCP['Type']
        };
        that.$set(that.FormData["CommunityPostages"], index, _data);
      } else {
        //新增
        var _data = {
          AreaID: aid ? aid : "",
          AreaName: aid ? aname : that.$t('newItem.noArea'),
          Status: 1, //1是包邮，2是顺丰到付，3是自定义价格
          Price: 0, //Status 3 自定义价格
          PriceMyUsd: 0, //Status 3 自定义价格
          Type: aid ? 2 : 1, //1 是全国默认邮费 2 是国内自定义邮费
        };
        that.FormData["CommunityPostages"].push(_data);
      }
      that.tempArea = {};
      that.tempAreaArr = []; //清空显示用选项
      that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
      //console.log('FormData[CommunityPostages]', that.FormData['CommunityPostages']);
      that.dialogVisible = false;
      that.E_item = "";
      that.CurCommunityPostages(); //获取已选区域
    },
    /*运费重排及去除type3、4*/
    ExcludedReSet() {
      var that = this;
      var _CommunityPostages = that.FormData["CommunityPostages"];
      //console.log("_CommunityPostages:", _CommunityPostages);
      var addDefault = function () {
        var _data = {
          AreaID: "0",
          AreaName: that.$t('newItem.domesticShipping'),
          Status: 1, //1是包邮，2是顺丰到付，3是自定义价格
          Price: 0, //Status 3 自定义价格
          PriceMyUsd: 0, //Status 3 自定义价格显示用USD Price
          Type: 1, //_CCP['Type']
        };
        that.FormData["CommunityPostages"].push(_data);
        that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
      };
      if (_CommunityPostages.length > 0) {
        var cp = _CommunityPostages.filter(function (obj, key) {
          obj["PriceMyUsd"] = that.$store.getters.priceExchange(
            obj["Price"],
            "USD"
          );
          if (obj["Type"] < 3) {
            // obj['Price'] = that.$store.getters.priceExchange(obj['Price'], 'USD');
            return obj;
          }
        });
        var Sort = function (array, key) {
          return array.sort(function (a, b) {
            var x = a[key];
            var y = b[key];
            return x < y ? -1 : x > y ? 1 : 0;
          });
        };
        var newCommunityPostages = Sort(cp, "Type");
        that.$set(that.FormData, "CommunityPostages", newCommunityPostages); //有编辑运费 清空AddressVersionCode
        if (newCommunityPostages.length <= 0) {
          addDefault();
        }
        that.CurCommunityPostages(); //获取已选区域
      } else {
        addDefault();
      }
    },
    /*获取已选区域[0,1,2,3...] 区域已用不可再选*/
    CurCommunityPostages() {
      var that = this;
      var curPost = [];
      that.FormData["CommunityPostages"].map(function (obj, k) {
        var c = obj["AreaID"].split("、");
        if (c.length > 0) {
          curPost = [...curPost, ...c];
        }
      });
      that.curPostages = curPost;
    },
    //价格判断
    PriceInput(type, fObj) {
      let that = this;
      let _Price = that.FormData[type]
        .toString()
        .replace(/[^\d.]/g, "") // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, ".") // 只保留第一个. 清除多余的
        .replace(/^\./g, "") //保证第一个为数字而不是.
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
      if (_Price.indexOf(".") < 0 && _Price != "") {
        _Price = parseFloat(_Price);
      }
      that.priceExchange("", type, fObj);
      that.$set(that.FormData, type, _Price);
      console.log(that.FormData);
    },
    //0:完成，1：未完成，2：无内容
    Steps(val, type) {
      var that = this;
      switch (val) {
        case "Photos":
          break;
        case "Details":
          /* 已迁至watch */
          break;
        case 1:
          break;
        case "Pricing":
          /* 定价状态变化 */
          if (type == "date") {
            /* 时间 */
            var time = that.StartTime;
            if (time) {
              // let CCT = that.$store.getters.cTime2CCT(time);
              let CCT = that.$store.getters.getTime(
                time,
                8,
                "cmtNull",
                "YYYY-MM-DD HH:mm:ss"
              );
              // console.log("CCT:", CCT);
              that.$set(that.FormData, "LastOnTime", CCT);
            }
          }
          if (type == "LimitNumber") {
            /* 限制购买数量<= 数量, LimitNumber<= QuantitySold*/
            if (that.FormData["LimitNumber"]) {
              var numb = that.FormData["QuantitySold"] ? that.FormData["QuantitySold"] : 1;
              if (that.FormData["LimitNumber"] > numb) {
                that.$set(that.FormData, "LimitNumber", numb);
              }
            }
          }
          if (type == "DepositNum" || type == "CreditNum") {
            /* CHP整数 */
            var val = parseInt(that.FormData[type]);
            if (parseInt(that.FormData[type]) <= 0) {
              val = 1;
            }
            that.$set(that.FormData, type, val);
          }
          //console.log(that.FormData['QuantitySold'], 1);
          var _EffectiveDay = that.FormData["EffectiveDay"] /*有效天数*/,
            _Price = that.FormData["Price"] /*商品价格*/,
            _Bargain = that.FormData["Bargain"] /*是否议价*/,
            _IsLimit = that.FormData["IsLimit"] /*是否限量*/,
            _ReleaseType = that.FormData["ReleaseType"] /*时间方式*/,
            _LastOnTime = that.FormData["LastOnTime"] /*上架时间*/,
            _IsDeposit = that.FormData["IsDeposit"] /*是否保证金*/,
            _DepositNum = that.FormData["DepositNum"] /*保证金金额*/,
            _CreditNum = that.FormData["CreditNum"]; /*信用金额*/

          //console.log("_ReleaseType", _ReleaseType, type);
          if (type == "ByWay") {
            that.$set(that.FormData, "EffectiveDay", null);
            that.$set(that.FormData, "Bargain", null);
            that.$set(that.FormData, "IsDeposit", null);
            that.$set(that.FormData, "QuantitySold", 1);
            that.minPrice = false;
            that.autoPrice = false; /* 切换类型 清空 */
          }
          if (_Bargain == 1) {
            that.$set(that.FormData, "QuantitySold", 1);
            that.$set(that.FormData, "IsLimit", 0);
            that.$set(that.FormData, "LimitNumber", null); /* 一口价允许议价 数量为1 限制购买数量 否*/
          }
          if (_Bargain == 0) {
            that.minPrice = false;
            that.autoPrice = false; /* 一口价不允许议价 清空 低于该价格自动拒绝、自动接受金额*/
          }
          if (_IsLimit <= 0) {
            that.$set(that.FormData, "LimitNumber", null); /* 限制购买数量 否 数量清空 */
          }
          if (type == "ByWay" && that.FormData["ByWay"] == 2) {
            that.$set(that.FormData, "Price", that.$store.getters.priceExchange(0.99, "")); /* 拍卖->价格=1 */
            that.$set(that.FormData, "PriceMyUsd", 0.99); /* 拍卖->价格=1 */
          }
          if (type == "ByWay" && that.FormData["ByWay"] == 1) {
            that.$set(that.FormData, "Price", null); /* 一口价->价格默认=null */
            that.$set(that.FormData, "PriceMyUsd", null); /* 一口价->价格默认=null */
          }
          if (type == "ReleaseType" && _ReleaseType == 0) {
            var d = util.getTime("yyyy-MM-dd HH:mm:ss");
            that.ClearCardStartTime();
            that.$set(that.FormData, "LastOnTime", d); /*马上开始 - 当前时间*/
          }
          if (type == "ReleaseType" && _ReleaseType == 1) {
            that.$set(that.FormData, "LastOnTime", "");
            that.StartTime = ""; /*安排个时间 - 时间清空 需重选*/
          }
          if (_IsDeposit <= 0) {
            that.$set(that.FormData, "DepositNum", null);
            that.$set(that.FormData, "CreditNum", null); /*保证金为否*/
          }
          that.$nextTick(function () {
            if (that.minPrice != true) {
              that.$set(that.FormData, "LPrice", null);
              that.$set(that.FormData, "LPriceMyUsd", null);
            }
            if (that.autoPrice != true) {
              that.$set(that.FormData, "HPrice", null);
              that.$set(that.FormData, "HPriceMyUsd", null);
            }
          });
          /* 定价状态变化 ed */

          /* steps 已迁至watch */
          break;
        case "Domestic":
          /* 已迁至watch */
          break;
      }
    },
    /*设置FormData部分属性（定价）*/
    setKeyVal() {
      var that = this;
      var _FormData = that.FormData;
      // if (_FormData["ByWay"] == undefined) {
      //   that.$set(that.FormData, "ByWay", 0);
      // }
      if (_FormData["ByWay"] == undefined || _FormData["ByWay"] == 0) {
        that.$set(that.FormData, "ByWay", 2);
      } // 新录入卡片，默认选择竞拍
      if (_FormData["IsLimit"] == undefined) { that.$set(that.FormData, "IsLimit", null); }
      if (_FormData["EffectiveDay"] == undefined) { that.$set(that.FormData, "EffectiveDay", null); }
      if (_FormData["Price"] == undefined || _FormData["Price"] == null) {
        that.$set(that.FormData, "Price", that.$store.getters.priceExchange(0.99, ""));
        that.$set(that.FormData, "PriceMyUsd", 0.99);
      }
      if (_FormData["ByWay"] == undefined || _FormData["ByWay"] == 2) {
        that.$set(that.FormData, "Price", that.$store.getters.priceExchange(0.99, ""));
        that.$set(that.FormData, "PriceMyUsd", 0.99);
      } //新录入卡片，默认选择竞拍 价格设置
      if (_FormData["Bargain"] == undefined) { that.$set(that.FormData, "Bargain", null); }
      if (_FormData["IsLimit"] == undefined) { that.$set(that.FormData, "IsLimit", null); }
      if (_FormData["ReleaseType"] == undefined) { that.$set(that.FormData, "ReleaseType", null); }
      if (_FormData["ByWay"] == undefined || _FormData["ByWay"] == 2) { that.$set(that.FormData, "ReleaseType", 0); } //上架时间默认选择立即上架
      if (_FormData["LastOnTime"] == undefined) { that.$set(that.FormData, "LastOnTime", null); }
      if (_FormData["IsDeposit"] == undefined) { that.$set(that.FormData, "IsDeposit", null); }
      if (_FormData["DepositNum"] == undefined) { that.$set(that.FormData, "DepositNum", null); }
      if (_FormData["CreditNum"] == undefined) { that.$set(that.FormData, "CreditNum", null); }
      //console.log("setKeyVal---that.FormData:", that.FormData);
    },
    /*自定义标题部分*/
    CustomInput() {
      var that = this;
      let value = that.FormData["CustomVal"];
      value = value.replace(/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig, '');
      value = value.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "");
      value = value.replace(/[\uE000-\uF8FF]/g, '');
      value = value.replace(/<\/?.+?>/g, "");
      value = value.replace(/[\r\n]/g, "");
      value = value.replace(/[\|\=]/g, "");
      //console.log(value)
      that.Custom = value.length;
      that.FormData["CustomVal"] = value;
      that.setCardTitle("", "", "CustomVal");
    },
    /*上传图片相关*/
    aiDeleteImg(type) {
      var that = this;
      switch (type) {
        case 'frontImgUrl':
          that.frontImgUrl = [];
          break;
        case 'backendImgUrl':
          that.backendImgUrl = [];
          break;
      }
      var _picList = this.picList
      _picList = _picList.filter(function (obj, kk) {
        if (obj['discern'] != type) {
          return obj
        }
      });
      this.picList = _picList
    },
    dltImgDiv(id, uploadId, valId, valKey) {
      //console.log("fun dltImgDiv:", id, uploadId, valId, valKey);
      var that = this;
      var _picList = this.picList;
      _picList = _picList.filter(function (obj, kk) {
        if (valKey == kk && obj.qrResult) {
          that.qrResult = '';
        }
        if (valKey == kk && _picList[kk]['discern']) {
          switch (_picList[kk]['discern']) {
            case 'frontImgUrl':
              that.frontImgUrl = [];
              break;
            case 'backendImgUrl':
              that.backendImgUrl = [];
              break;
          }
        }
        if (valKey != kk) { return obj }
      });
      this.picList = _picList;//------------
      var _picList2 = this.picListLocal;
      _picList2 = _picList2.filter(function (obj, kk) {
        if (valKey == kk && obj.qrResult) {
          that.qrResult = '';
        }
        if (valKey == kk && _picList2[kk]['discern']) {
          switch (_picList2[kk]['discern']) {
            case 'frontImgUrl':
              that.frontImgUrl = [];
              break;
            case 'backendImgUrl':
              that.backendImgUrl = [];
              break;
          }
        }
        if (valKey != kk) { return obj }
      });
      that.picListLocal = _picList2;
      if (this.uploadImgType == 'rating') {
        that.setShowImgList(that.picListLocal)
        that.decodeQR();
      } else {
        that.setPic2Form();
      }
      //deleteImageDiv(id, uploadId);//public.js
    },
    /*富文本初始化*/
    wangEditor() {
      var that = this;
      // @* https://www.wangeditor.com/*@
      if (document.getElementById("RichText")) {
        editor = new E("#RichText");
        //console.log(editor)
        var eLang = that.$store.state.lang || "en";
        editor.config.lang = eLang == 'zh-tw' ? 'zh_traditional' : 'en';
        if (eLang == 'zh-tw') {
          editor.config.languages['zh_traditional'] = require("../../common/wangeditor-lang/zh_tw.json");
        }
        editor.i18next = i18next;
        // editor.config.showMenuTooltips = false;// 隐藏提示
        editor.config.uploadImgShowBase64 = true;
        editor.config.height = 200;
        editor.config.zIndex = 1;
        // 配置菜单栏，设置不需要的菜单
        editor.config.excludeMenus = [
          "emoticon",
          "image",
          "todo",
          "table",
          "code",
          "video",
          "link",
        ];
        editor.config.placeholder = "";
        editor.config.onblur = function (newHtml) {
          //console.log('wangEditor onblur', newHtml)
          //失焦 获取html 赋值Formdata
          that.$set(that.FormData, "Description", encodeURIComponent(newHtml)); //需url编码
        };
        // 防止失焦获取失败，加一个change事件
        editor.config.onchange = function (newHtml) {
          //console.log('wangEditor onblur', newHtml)
          //失焦 获取html 赋值Formdata
          that.$set(that.FormData, "Description", encodeURIComponent(newHtml)); //需url编码
        };
        // 为了防止mac出现全选黏贴内容有问题，这个onSelectionChange事件不要去掉
        editor.config.onSelectionChange = function (newSelection) { };
        editor.create();
      }
    },
    getEditor() {
      //获取富文本HTML

      // 获取编辑器区域完整html代码
      var html = editor.txt.html();
      //console.log("html方法：" + html);

      // 获取编辑器纯文本内容
      var text = editor.txt.text();
      //console.log("text方法：" + text);
    },
    /*展示图上传*/
    checkImgRule(file, tips = true) {
      var that = this;
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt5M = file.size > (1024 * 1024 * 10) ? false : true;
      // console.log("checkImgRule", file)

      if (!isJPG) {
        if (tips) {
          that.$message.warning({ message: '上传图片只能是 JPG/PNG 格式!', offset: this.msgOffset });
        }
        return false;
      }
      if (!isLt5M) {
        if (tips) {
          that.$message.warning({
            message: this.$t('newItem.photosWarningSize', { a: "10 MB" }), //'上传图片大小不能超过 5MB!', 
            offset: this.msgOffset
          });
        }
        return false;
      }
      //var isSize = that.uploadWidth(file);
      return isJPG && isLt5M; // && isSize;
    },
    beforeUpload(file) {
      var that = this;

      var imgRule = that.checkImgRule(file);
      if (!imgRule) return;

      if (that.uploadImgType == 'rating') {
        that.picList = [
          //...that.picList,
          ...that.picListLocal
        ];

      } else if (that.uploadImgType == 'normal') {
        var _sort = that.picList.length ? 1 : that.picList.length + 1;
        var _type = that.picList.length ? 1 : 3;
        that.picList = [
          ...that.picList,
          {
            id: new Date().getTime(),
            ImageUrl: "/static/images/noimg.svg",
            type: _type,
            Sort: _sort,
          },
        ];
      }
      that.setPic2Form();
      //that.$message.error('上传图片分辨率建议800*600以上!');
    },
    uploadWidth(file) {
      //判断上传图片width、height限制
      var that = this;
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let image = new Image();
        image.onload = function () {
          //控制图片上传大小方法
          var _imgWidth = image.width;
          var _imgHeight = image.height;
          //console.log(_imgWidth, _imgHeight);
          let valid = _imgWidth < 800 || _imgHeight < 600 ? false : true;
          valid ? resolve() : reject();
        };
        image.src = _URL.createObjectURL(file);
      }).then(
        function () {
          //that.uploadFile.append('file', file);
          that.uploadFile = file;
          return file;
        },
        function () {
          that.$message.warning(
            "You can drag to sort photos.The first photo selected will be the main photo to be shown as the cover.  You can upload a max of 5 photos at a minimum of 800x600 pixels. "
          );
          return Promise.reject();
        }
      );
      return isSize;
    },
    NewCos() {
      var that = this;
      //console.log(new Date(new Date().getTime() + 1.5 * 60 * 60 * 1000));
      cos = new COS({
        getAuthorization: function (options, callback) {
          console.log("options:", options);
          // 异步获取临时密钥
          if (that.$cookie.get("cosData")) {
            cosData = JSON.parse(that.$cookie.get("cosData"));
            //console.log("$cookie.get.costoken", cosData);
            var credentials = cosData.Credentials;
            var cb = {
              TmpSecretId: credentials.TmpSecretId,
              TmpSecretKey: credentials.TmpSecretKey,
              SecurityToken: credentials.Token,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
              ExpiredTime: parseInt(cosData.ExpiredTime), // 时间戳，单位秒，超时时刻的时间戳
            };
            //console.log("callback",cb);
            callback(cb);
          } else {
            //var url = 'http://world.cardhobby.cn/upload/gettoken';
            that.$get("costoken", "none").then((res) => {
              //console.log("costoken", res);
              try {
                cosData = res;
                that.$cookie.set("cosData", JSON.stringify(res), {
                  expires: new Date(
                    new Date().getTime() + 1.5 * 60 * 60 * 1000
                  ),
                });
                //console.log("getAuthorization2 - data", cosData);
                var credentials = cosData.Credentials;
              } catch (e) { }
              if (!cosData || !credentials) {
                return console.error("credentials invalid:\n" + cosData);
              }
              var cb = {
                TmpSecretId: credentials.TmpSecretId,
                TmpSecretKey: credentials.TmpSecretKey,
                SecurityToken: credentials.Token,
                // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
                ExpiredTime: parseInt(cosData.ExpiredTime), // 时间戳，单位秒，超时时刻的时间戳
              };
              //console.log("callback",cb);
              callback(cb);
            })
              .catch((err) => {
                console.log(err);
              });
            // var xhr = new XMLHttpRequest();
            // xhr.open('GET', url, true);
            // xhr.onload = function (e) {
            //   //console.log("getAuthorization2", e);
            //   //////////////
            // };
            // xhr.send();
          }
        },
      });
    },
    setWebPics(url) {
      var that = this;
      var noimg = 0;
      if (that.uploadImgType == 'rating') {
        that.picListLocal.filter((img, k) => {
          if (img['ImageUrl'].indexOf("blob") > -1) {
            noimg = k;
          }
        });
        that.picListLocal[noimg]['ImageUrl'] = url;
        that.picListLocal[noimg]['isPreviewImg'] = false;
        setTimeout(function () {
          that.ratingHandleClose()
        }, 1500);
      } else if (that.uploadImgType == 'ai') {
        // POST /discern/image/upload
        if (that.aiImgType == 'frontImgUrl') {
          that.frontImgUrl = [{ name: 'frontImgUrl', url: url }];
        } else if (that.aiImgType == 'backendImgUrl') {
          that.backendImgUrl = [{ name: 'backendImgUrl', url: url }];
        }

      } else {
        that.picList.filter((img, k) => {
          if (img['ImageUrl'].indexOf("noimg") > -1) {
            noimg = k;
          }
        });
        that.picList[noimg]['ImageUrl'] = url;
        that.picList[noimg]['isPreviewImg'] = false;
        that.setPic2Form();
      }
    },
    checkAiImgLeng() {
      //AI识别图片与图片列表和 数量限制
      var that = this;
      var aiLeng = 0;
      that.picList.filter((img, k) => {
        if (img['discern']) {
          aiLeng++
        }
      })
      // console.log("checkAiImgLeng", that.picList.length, aiLeng, that.picListLimit);
      //图片列表长度-识别图片长度+AI图片长度+1>图片列表限制
      if (that.picList.length - aiLeng + that.frontImgUrl.length + that.backendImgUrl.length + 1 > that.picListLimit) {
        that.$message.warning({ message: that.$t('newItem.photosWarning', { a: this.picListLimit }), offset: this.msgOffset });
        return false;
      }
      return true;
    },
    uploadImgFI(file) {
      var that = this;
      var imgRule = that.checkImgRule(file.file, false);
      var imgRuleLeng = that.checkAiImgLeng();
      if (!imgRule || !imgRuleLeng) {
        that.frontImgUrl = [];
        return
      };

      this.aiImgType = 'frontImgUrl';
      this.uploadImg(file);
    },
    uploadImgBI(file) {
      var that = this;
      var imgRule = that.checkImgRule(file.file, false);
      var imgRuleLeng = that.checkAiImgLeng();
      if (!imgRule || !imgRuleLeng) {
        that.backendImgUrl = [];
        return
      };

      this.aiImgType = 'backendImgUrl';
      this.uploadImg(file);
    },
    setAiImg() {
      var that = this;
      var hasFI = false;
      var hasBI = false;
      for (var i = 0; i < that.picList.length; i++) {
        if (that.picList[i].discern == 'frontImgUrl') {
          hasFI = true;
        }
        if (that.picList[i].discern == 'backendImgUrl') {
          hasBI = true;
        }
      }
      if (that.frontImgUrl.length && !hasFI) {
        that.picList.push({
          "ImageUrl": that.frontImgUrl[0].url,
          "Sort": 1,
          "discern": 'frontImgUrl',
          'type': 3
        });
      }
      if (that.backendImgUrl.length && !hasBI) {
        that.picList.push({
          "ImageUrl": that.backendImgUrl[0].url,
          "Sort": 2,
          "discern": 'backendImgUrl',
          'type': 3
        });
      }
      that.setPic2Form();
    },
    cancelRecognition() {
      this.aiLoading = false;
      this.aiCancel = true;
    },
    aiSubmit() {
      // GetingotV2 [POST] /discern/v2
      var that = this;
      if (that.frontImgUrl.length > 0 && that.backendImgUrl.length > 0) {
        var fdata = {
          "frontImgUrl": that.frontImgUrl[0].url,
          "backendImgUrl": that.backendImgUrl[0].url
        }//that.aiDiscernData;
        that.aiLoading = true;
        that.aiCancel = false;
        that.aiCancelShow = false;
        setTimeout(function () {
          that.aiCancelShow = true;
        }, 5000);
        that.$post('GetingotDiscern', fdata).then((res) => {
          console.log("aiSubmit-res", res);
          if (!that.aiCancel) {
            if (res.result) {
              var _data = res.data;
              if (_data['PropertyJson']) {
                console.log("aiSubmit-PropertyJson", JSON.parse(decodeURIComponent(_data['PropertyJson'])));
                // console.log("aiSubmit-PropertyJson", encodeURIComponent(JSON.stringify(_data['PropertyJson'])));
                // _data['PropertyJson']=encodeURIComponent(JSON.stringify(_data['PropertyJson']));
                var cFun = function () {
                  that.CardEdit('ai')
                }
                if (_data['ThirdCategoryId']) {
                  that.getData('GetCommodityTitleRuleByThirdCategoryId', `?ThirdCategoryId=${_data['ThirdCategoryId']}`, '', 'ctgChange', cFun);
                } else {
                  cFun();
                }
                that.FormData = { ...that.FormData, ..._data };
                that.$set(that.FormData, 'DraftId', that.DraftId);
                that.tempPropertyJson = { ...that.tempPropertyJson, ..._data['PropertyJson'] };
                that.setAiImg();
                setTimeout(function () {
                  that.aiHandleClose('success');
                  that.showMorePro = true;
                }, 1800)
              } else {
                that.$message({
                  message: '识别失败~',
                  type: 'warning'
                });
                that.aiLoading = false;
              }
            } else {
              that.$message({
                message: res.Msg || '识别失败~',
                type: 'warning'
              });
              that.aiLoading = false;
            }
          }
        }).catch((err) => {
          console.log(err);
          that.aiCancelShow = true;
        });
      }
    },
    uploadImg(imgFd) {
      console.log('uploadImg:', imgFd);
      var that = this;
      var uploadType = process.env.NODE_ENV == "development" ? "api" : "cos"; //cos api
      //  return;
      var errDltImg = function () {
        if (that.uploadImgType != 'ai') {
          that.picList = that.picList.filter((img, k) => {
            //删除上传失败的图片
            if (img["ImageUrl"].indexOf("noimg") == -1) {
              return img
            }
          });
          that.picListLocal = that.picListLocal.filter((img, k) => {
            //删除上传失败的图片
            if (img['ImageUrl'].indexOf("blob") == -1) {
              //console.log(img)
              return img
            }
          });
        }
      };

      if (uploadType == "cos") {
        /* COS 传图 */
        var myGuid = Guid.raw();
        var cosConfig = that.$store.state.cosConfig;
        //console.log("myGuid", myGuid.replace(/-/g, ""), " imgFd:", imgFd);
        var fileType = imgFd.type == "image/png" ? ".png" : ".jpg";
        var imgKey = cosConfig.Prefix + myGuid.replace(/-/g, "") + fileType;
        cos.putObject(
          {
            Bucket: cosConfig.Bucket /* 必须 */,
            Region: cosConfig.Region /* 存储桶所在地域，必须字段 */,
            Key: imgKey /* 必须 */,
            Prefix: cosConfig.Prefix,
            StorageClass: "STANDARD",
            Body: imgFd.file, // 上传文件对象
            Headers: {
              "x-cos-request-id": cosData.RequestId,
            },
            onProgress: function (progressData) {
              console.log("onProgress:", JSON.stringify(progressData));
            },
          },
          function (err, data) {
            // console.log("err", err);
            // console.log("data", data);
            if (err) {
              that.$message.error(that.$t('newItem.photoFailed'));
              errDltImg();
              that.setPic2Form();
            } else {
              var _url = that.ImagesUrl + imgKey;
              that.setWebPics(_url);
            }
          }
        );
      } else {
        /* 接口传图 */
        var fd = new FormData();
        console.log("file", imgFd.file)
        fd.append("file", imgFd.file);
        that.axios.post(that.uploadUrl, fd).then((res) => {
          console.log("upload.post", res)
          if (res.result) {
            that.setWebPics(res.data)
          } else {
            this.$message.error(that.$t('newItem.photoFailed'));
            errDltImg();
            that.setPic2Form();
          }
        }).catch((err) => {
          console.log("upload img catch", err);
          errDltImg();
          that.setPic2Form();
        });
      }
    },
    uploadImgChange(file, fileList) {
      var that = this;
      if (that.uploadImgType == 'rating') {
        //console.log("uploadImgChange", file, fileList)
        var imgRule = that.checkImgRule(file.raw);
        //console.log("imgRule", imgRule)
        if (!imgRule) return;
        var _sort = that.picList.length ? 1 : that.picList.length + 1;
        var _type = that.picList.length ? 1 : 3;
        that.picListLocal = [
          ...that.picListLocal,
          {
            id: new Date().getTime(),
            ImageUrl: file.url,//页面显示本地预览blob图
            localfile: file.raw,//decodeQR
            isPreviewImg: true,
            type: _type,
            Sort: _sort,
          },
        ];
        that.decodeQR();
        //that.setPic2Form();
      }
    },
    submitUpload() {
      var that = this;
      var companyCode = '',
        code = '',
        _index = -1,
        list = this.picListLocal;
      var codelist = ['PSA', 'CGC', 'GONGBO'];//GBTC:gongbo
      list.map(function (obj, k) {
        if (obj.qrResult && _index <= -1) {
          var _qrResult = obj.qrResult.split("//")[1].split("/");
          var comp = _qrResult[0].toUpperCase();
          codelist.map((val, k) => {
            if (comp.includes(val)) {
              _index = k;
            }
          })
          if (_index > -1) {
            code = _qrResult[2];
            companyCode = codelist[_index] == 'GONGBO' ? 'GBTC' : codelist[_index];
          }
        }
      });
      //console.log("companyCode:", companyCode, " code:", code, ' _index:', codelist[_index]);
      if (companyCode && code) {
        that.getData('GetNewCommodityByCode', `?companyCode=${companyCode}&code=${code}`);
        try {
          that.$refs.ratingUpload.submit();
        } catch (err) {
          console.log('ratingUpload.submit', err)
          //alert('ratingUpload.submit'+ err);
        }
      } else {
        that.$confirm('识别失败，是否继续？', '', {
          showClose: false,
          closeOnClickModal: false
        }).then(_ => {
          that.$refs.ratingUpload.submit();
        })
          .catch(_ => { });
      }
    },
    decodeQR(list) {
      var that = this;
      var list = list ? list : that.picListLocal;
      if (list.length && that.qrResult == '') {
        that.decodeLoading = true;
        //console.log("---reDecodeQR---")
        var jsQrfun = function (obj, k) {
          if (!that.qrResult && !obj['qrResult']) {
            that.decodeLoading = true;
            /**** jsQR ********************************************************/
            const reader = new FileReader();
            reader.onload = (e) => {
              const data = e.target.result;
              const cvs = document.createElement('canvas');
              const img = new Image();
              img.onload = () => {
                cvs.width = img.width;
                cvs.height = img.height;
                const ctx = cvs.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const imageData = ctx.getImageData(0, 0, cvs.width, cvs.height);
                const code = jsQR(imageData.data, cvs.width, cvs.height);
                //console.log("jsQr:", k, code);
                if (code) {
                  console.log("SetjsQr:", k);
                  that.qrResult = code.data;
                  obj['qrResult'] = code.data
                } else {
                  that.qrResult = '';
                  obj['qrResult'] = ''
                }
                if (k == list.length - 1) {
                  that.decodeLoading = false;
                }
              };
              img.src = data;
            };
            reader.readAsDataURL(obj.localfile);
          }
        }
        that.picListLocal = list.filter(function (obj, k) {
          if (obj.localfile && that.qrResult == '') {
            /**** html5QrCode ********************************************************/
            var html5QrCode = new Html5Qrcode("reader");
            html5QrCode.scanFile(obj.localfile, false)
              .then(qrCodeMessage => {
                // success, use qrCodeMessage
                console.log("html5QrCode:", k);
                if (qrCodeMessage) {
                  that.qrResult = qrCodeMessage;
                  obj['qrResult'] = qrCodeMessage;
                  if (k == list.length - 1) {
                    that.decodeLoading = false;
                  }
                } else {
                  that.qrResult = '';
                  obj['qrResult'] = '';
                  jsQrfun(obj, k)
                }
              })
              .catch(err => {
                // failure, handle it.
                //console.log(`html5QrCode Error: ${err}`)
                jsQrfun(obj, k)
              });
            /**------------------------------------------**/
          } else {
            that.decodeLoading = false;
          }
          return obj
        });
        //setTimeout(function () {
        //    that.picListLocal = _newList;
        //}, 1000);
      }
      //console.log("decodeQR:", list, that.qrResult)
    },
    ratingDialog(type) {
      var that = this;
      that.picListLocal = that.picList;
      that.uploadImgType = type;
      that.ratingDialogVisible = true;
      that.decodeQR();
    },
    ratingHandleClose() {
      var that = this;
      var close = false;
      var list = that.picListLocal;
      if (list.length) {
        list.filter(function (obj, k) {
          if (obj['ImageUrl'].indexOf("blob") > -1) {
            close = true
          }
        })
      }
      var fun = function () {
        that.uploadImgType = 'normal';
        that.ratingDialogVisible = false;
        var picListLocal = that.picListLocal;
        if (close) {
          picListLocal = picListLocal.filter(function (obj, k) {
            if (obj['ImageUrl'].indexOf("blob") <= -1) {
              return obj
            }
          });
        }
        that.picList = picListLocal
        setTimeout(function () {
          that.picListLocal = [];
          that.setPic2Form();//图片写入FormData
        }, 1000);
      }
      if (close) {
        this.$confirm('有未上传图片，确认关闭？', '', {
          showClose: false,
          closeOnClickModal: false,
          //center: true,
          //type: 'warning'
        }).then(_ => {
          fun();
        })
          .catch(_ => { });
      } else {
        fun();
      }
    },
    aiDialog(type = 'ai') {
      var that = this;
      that.uploadImgType = type;
      that.aiDialogVisible = true;
    },
    aiHandleClose(type) {
      var that = this;
      var fun = function () {
        that.uploadImgType = 'normal';
        that.aiDialogVisible = false;
      }
      if (type == 'success') {
        that.aiLoading = false;
        fun();
      } else {
        if (that.frontImgUrl.length || that.backendImgUrl.length) {
          this.$confirm(that.$t('newItem.closeTips'), '', {
            showClose: false,
            closeOnClickModal: false,
            //center: true,
            //type: 'warning'
          }).then(_ => {
            that.setAiImg();
            fun();
          })
            .catch(_ => { });
        } else {
          fun();
        }
      }
    },
    uploadImgSuccess(response, file, fileList) {
      var that = this;
      //console.log('----uploadImgSuccess---');
      if (file.status == "success") {
        var _sort = that.picList.length ? 1 : that.picList.length + 1;
        var _type = that.picList.length ? 1 : 3;
        that.picList = [
          ...that.picList,
          {
            id: new Date().getTime(),
            ImageUrl: file.response.data,
            type: _type,
            Sort: _sort,
          },
        ];
        that.setPic2Form();
      } else {
        console.log(response, file);
        this.$message.error(that.$t('newItem.photosErr')); //请求图片地址失败
      }
    },
    uploadImgError(err, file, fileList) {
      console.log("----uploadImgError---");
      console.log(err, file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        this.$t('newItem.photosWarning', { a: this.picListLimit })//`You can upload no more than ${this.picListLimit} photos`
      );
      //this.$message.warning(`当前限制选择 5 张，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}?`);
    // },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    /*展示图拖曳*/
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    /*首先把div变成可以放置的元素，即重写dragenter/dragover*/
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move"; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item) {
      var that = this;
      e.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      var newItems = [...this.picList];
      //console.log(newItems)
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));

      newItems = newItems.filter(function (obj, key) {
        obj["Sort"] = key + 1;
        if (key <= 0) {
          obj["type"] = 3;
        } else {
          obj["type"] = 1;
        }
        return obj;
      });
      this.picList = newItems;
      that.setPic2Form(); //图片写入FormData
      //console.log("handleDragEnter:FormData:",that.FormData);
    },
    /*展示图拖曳end*/
    setPic2Form() {
      var that = this;
      that.setShowImgList(that.picList);
      that.$set(that.FormData, "NewCommunityImages", that.picList); //图片写入FormData
    },
    //预览大图重新排序，显示当前点击项
    imageClicked(imageUrl, index) {
      let imgList = JSON.parse(JSON.stringify(this.showImgList));
      let _index = imgList.findIndex((item) => item == imageUrl);
      let afterPicArr = imgList.slice(_index);
      let beforePicArr = imgList.slice(0, _index);
      this.showImgList = afterPicArr.concat(beforePicArr);
    },
    // 展示图放大数组组合 
    setShowImgList(val) {
      let show = [];
      if (val.length) {
        val.map((res) => {
          show.push(res.ImageUrl);
        });
        this.showImgList = show;
      }
    },
    /*标题悬浮置顶*/
    scrollToTop() {
      let that = this;
      var wTop = $("body,html").scrollTop();
      var tbHeight = $("#TitleBox").outerHeight();
      var Header = $("#Header").outerHeight();
      var main_w = $("#ManageBox").outerWidth();
      //console.log(wTop, tbHeight, that.tTop);
      if (wTop <= that.tTop) {
        $("#TitleBox").css({ position: "inherit", width: "100%" });
        $("#TitleBox").removeClass("title-fixed");
      } else {
        var _top = wTop - tbHeight >= 0 ? wTop - tbHeight : wTop;
        $("#TitleBox").css({
          position: "fixed",
          top: Header + 1 + "px",
          left: "310px",
          width: main_w + "px",
        });
        $("#TitleBox").addClass("title-fixed");
      }
    },
    /* 价格转换 RMB USD */
    priceExchange(type, myObj, fObj) {
      /*
       *type:转换类型, myObj:显示用价格对象, fObj：表单提交价格对象
       * 显示用价格对应格式  xxxMyUsd
       */
      var that = this;
      type = type || ""; //USD ,'';
      console.log(type, myObj, fObj);
      if (type == "USD") {
        //rmb->usd
        that.FormData["PriceMyUsd"] = that.$store.getters.priceExchange(that.FormData["Price"], type);
        that.FormData["LPriceMyUsd"] = that.$store.getters.priceExchange(that.FormData["LPrice"], type);
        that.FormData["HPriceMyUsd"] = that.$store.getters.priceExchange(that.FormData["HPrice"], type);
        let CommunityPostages = that.FormData["CommunityPostages"];
        CommunityPostages.map((obj, k) => {
          if (obj.Price) {
            that.FormData["CommunityPostages"][k]["PriceMyUsd"] =
              that.$store.getters.priceExchange(obj.Price, type);
          }
        });
      } else {
        //usd->rmb
        if (myObj == "CommunityPostages") {
          let CommunityPostages = that.FormData["CommunityPostages"];
          CommunityPostages.map((obj, k) => {
            if (obj.PriceMyUsd) {
              that.FormData["CommunityPostages"][k]["Price"] =
                that.$store.getters.priceExchange(obj.PriceMyUsd, type);
            }
          });
        } else {
          that.FormData[fObj] = that.$store.getters.priceExchange(that.FormData[myObj], type);
        }
      }
      // console.log("new.FormData:", that.FormData);
    },
    /*锚链接跳转*/
    anchor(anchorName) {
      // 找到锚点
      this.$nextTick(() => {
        $("#Main").scrollTop(document.getElementById(anchorName).offsetTop);
      });
    },
    // 协议弹框
    GetAgreements(AgreementTitle, type) {
      let that = this;
      that.AgreementTitle = AgreementTitle;
      that.AgreementsLoading = true;
      that.AgreementVisible = true;
      that.Agreements = "";
      this.$get("GetNewServiceAgreements", `?ServiceAgreementType=${type}`).then(res => {//获取国外有效合规文档
        if (res.Result) {
          if (res.Data.length > 0) {
            that.Agreements = res.Data[0]["Content"];
          }
        } else {
          that.Agreements = "";
          // that.AgreementVisible = false;
        }
        that.AgreementsLoading = false;
      }).catch(err => {
        that.AgreementVisible = false;
        that.AgreementsLoading = false;
        that.Agreements = "";
      })
    },
    // 关闭协议弹框
    handleAgreementsClose() {
      this.Agreements = "";
      this.AgreementVisible = false;
      this.AgreementsLoading = false;
    },
    CloseEndingList(type) {
      this.ShowEndingList = type;
    },
    /*提交表单*/
    async formSubmit(formName, SaveType, saveContinue) {
      /*
       * SaveType - 1: 保存
       * SaveType - 0: 草稿
       */
      var that = this;
      var uid = that.UserInfo.Id;
      that.$set(that.FormData, "SaveType", SaveType);
      that.$set(that.FormData, "MemberId", that.UserInfo.MappingUserId);
      that.$set(that.FormData, "operator_id", that.UserInfo.MappingUserId);
      that.$set(that.FormData, "token", that.$store.state.ChToken);
      that.$set(that.tempPropertyJson, "token", that.$store.state.ChToken);
      var tempPropertyJson = that.tempPropertyJson;
      console.log("that.PropertyList:", that.PropertyList);
      //console.log("arrayToQueryString--PropertyJson:", tempPropertyJson);
      if (tempPropertyJson && that.PropertyList.length) {
        var jsonEncode = util.jsonEncode(tempPropertyJson, that.PropertyList);
        that.$set(that.FormData, "PropertyJson", jsonEncode);
      }
      this.$nextTick(() => {
        console.log("that.FormData:", that.FormData);
        //console.log("EncodePropertyJson:", that.FormData['PropertyJson']);
        if (SaveType == 1) {
          if (that.FormData["PropertyJson"] == undefined) {
            this.$message.warning("Please complete the information"); //请完善信息
            $("#Main").scrollTop(0);
            return;
          }
          //return false;
          if (
            that.FormData["ThirdCategoryId"] == "" ||
            that.FormData["ThirdCategoryId"] == undefined
          ) {
            that.ctgErr = true;
            $("#Main").scrollTop(0);
            return;
          }
          if (
            that.FormData["NewCommunityImages"] == null ||
            that.FormData["NewCommunityImages"].length <= 0
          ) {
            this.$message.warning(that.$t('newItem.plsUploadPhotos')); //请上传照片
            that.imgErr = true;
            $("#Main").scrollTop(document.getElementById("Picture").offsetTop);
            return;
          }
          var noimg = 0;
          that.FormData['NewCommunityImages'].filter((img, k) => {
            if (img['ImageUrl'].indexOf("noimg") > -1) {
              noimg++;
            }
          });
          if (noimg > 0) {
            that.$message.warning({ message: 'Wait for picture upload to complete' });
            that.imgErr = true;
            $("#Main").scrollTop(document.getElementById("Picture").offsetTop);
            return
          }
          if (that.titleLength > that.titleMax) {
            this.$message.warning(
              "Title should be no more than 100 characters!"
            );
            $("#Main").scrollTop(document.getElementById("Detail").offsetTop);
            return;
          }
          if (!that.FormData["Title"] || that.FormData["Title"] == "") {
            this.$message.warning({
              message: that.$t('tips.plsGenerateTitle'),
              offset: this.msgOffset,
            });
            $("#Main").scrollTop(document.getElementById("Detail").offsetTop);
            return;
          }
          this.$refs.CreateCardForm.validate(function (valid) {
            if (valid) {
              console.log("success validate!!");
              if (uid) {
                if (that.clone) {
                  that.$set(that.FormData, "Id", "");
                }
                that.submitLoading = true;
                that.loading = true;
                //that.priceExchange(); //汇率转换 usd-rmb
                setTimeout(() => {
                  that.getData("SaveCommodity", that.FormData, "", saveContinue);
                }, 800);
              }
            } else {
              //that.$set(that.FormData, 'PropertyJson', '');
              console.log("error submit!!");
              that.submitLoading = false;
              if (that.DetailsSteps > 0) {
                //详情
                $("#Main").scrollTop(
                  document.getElementById("Detail").offsetTop
                );
                return false;
              } else if (that.PricingSteps > 0) {
                //定价
                $("#Main").scrollTop(
                  document.getElementById("Price").offsetTop
                );
                return false;
              } else if (that.DomesticSteps > 0) {
                //运费
                $("#Main").scrollTop(
                  document.getElementById("Logistics").offsetTop
                );
                return false;
              } else {
                $("#Main").scrollTop(document.getElementById("Price").offsetTop);
              }
              return false;
            }
          });
        } else {
          that.submitLoading = true;
          that.loading = true;
          //that.priceExchange(); //汇率转换 usd-rmb
          setTimeout(() => {
            that.getData("SaveDraftCommodity", that.FormData);
          }, 800);
        }
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/iconfont/iconfont.css";
@import "../../../static/css/addcard.css";
@import "../../../static/css/ele.css";

.body_title {
  overflow-y: auto;
}

/deep/ .row-block .el-form-item__error {
  position: absolute;
  padding-top: 0;
  top: 35%;
  left: 110%;
  width: 200px;
}

/deep/ .up-img-btn .el-upload {
  height: 100%;
  width: 100%;
}

.up-img-btn>div {
  height: 100%;
}

.up-img-btn .picture_list {
  width: 100%;
  height: 100%;
  /* display: flex; */
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.list_item {
  width: fit-content;
  display: block;
}

/deep/ .ai-card-box .el-upload-dragger {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/commodity/newitem.vue